export const fr = {
  // Menu principal
  menu: {
    spaces: 'Espaces',
    sources: 'Sources',
    // V4-FRONT-NAMING-WIZARD-VEILLE 2026-06-03 — "Centres d'intérêt" partout (décision utilisateur,
    // revert du V4-NAMING-VEILLE). Clés objet (watch:, SIDEBAR_ITEMS.WATCH='veille') inchangées = ids techniques.
    // V4-FRONT-NAMING-THEMATIQUES 2026-06-22 — "Centres d'intérêt" → "Thématiques" (3e renommage : Veille→Centres→Thématiques).
    watch: 'Thématiques',
    positioning: 'Positionnement',
    channels: 'Canaux',
    newsletter: 'Newsletter',
    automations: 'Automatisations',
    posts: 'Publications',
    appearance: 'Apparence',
    settings: 'Paramètres',
    brandConfig: 'Charte graphique',
    analytics: 'Analytics',
    engagement: 'Engagement',
    history: 'Historique',
  },

  // Sidebar
  sidebar: {
    account: 'Compte',
    logout: 'Se déconnecter',
    saveChanges: 'Enregistrer les modifications',
    publicationsComingSoon: 'Publications',
    newsletterComingSoon: 'Newsletter - Bientôt disponible',
    historyTooltip: 'Historique des publications',
    switchSpace: 'Changer d\'espace',
  },

  // V4-ANALYTICS-HISTORY — History panel (right sidebar).
  history: {
    title: 'Historique des publications',
    metricViews: 'Vues',
    metricLikes: 'Likes',
    metricComments: 'Commentaires',
    metricShares: 'Partages',
    granDaily: 'Quotidien',
    granWeekly: 'Hebdomadaire',
    granMonthly: 'Mensuel',
    loading: 'Chargement…',
    empty: "Pas encore de données d'historique. Les statistiques apparaîtront une fois vos posts publiés et leurs métriques collectées.",
    weekAbbrev: 'Sem',
    topTopics: 'Sujets abordés',
    topSources: 'Sources principales',
    postsActivity: 'Activité de publication',
    totalPosts: 'Total',
    postsLastMonth: 'Dernier mois',
    postsVariation: 'Variation',
    globalStats: 'Statistiques globales',
    positioningTitle: 'Positionnement',
    improvePositioning: 'Améliorer le positionnement',
    noPositioning: 'Aucun positionnement spécifique défini pour ce canal.',
    generatePositioning: 'Générer un positionnement',
    positioningSoon: 'Bientôt disponible',
    openPost: 'Ouvrir le post',
    noData: 'Aucune donnée',
    savePositioning: 'Enregistrer',
    analyticsUnavailable: 'Analytics indisponibles (add-on Zernio requis)',
  },

  // Agence
  agency: {
    myAgency: 'Mon agence',
    members: 'Membres',
    billing: 'Facturation',
    roleOwner: 'Propriétaire',
    roleMember: 'Membre',
    spaceRoleOwner: 'Propriétaire',
    spaceRoleEditor: 'Éditeur',
    spaceRoleViewer: 'Lecteur',
    spacesTitle: 'Gestion des espaces',
    seatsUsed: 'espaces utilisés',
    createSpace: 'Créer un espace',
    editSpace: 'Modifier l\'espace',
    deleteSpace: 'Archiver l\'espace',
    noClientEmail: 'Aucun email client renseigné',
    guestEmailsLabel: 'Emails invités (lecture seule)',
    addGuestEmail: 'Ajouter un email puis Entrée',
    guestEmailsHint: 'Ces personnes auront un accès en lecture seule à cet espace.',
    invalidEmailFormat: 'Format d\'email invalide',
    firstClient: {
      ctaTitle: 'Créez votre premier espace client',
      ctaDesc: 'Un espace par client : positionnement, sources et publications dédiés.',
      title: 'Créer votre premier espace client',
      subtitle: 'Chaque client a son propre espace, isolé et configurable.',
      nameLabel: 'Nom du client',
      namePlaceholder: 'Ex : Boulangerie Martin',
      inviteLabel: 'Inviter le client (lecture seule) — optionnel',
      inviteHint: 'Il pourra consulter les publications de son espace, sans les modifier.',
      create: 'Créer l\'espace',
      creating: 'Création…',
      later: 'Plus tard',
      createError: 'La création de l\'espace a échoué',
      createdTitle: 'Espace « {name} » créé',
      createdDesc: 'Configurez-le maintenant (positionnement, sources, canaux) pour générer ses premières publications.',
      configureNow: 'Configurer maintenant',
    },
    upgradeSeats: 'Ajouter des sièges',
    spaceQuotaReachedHint: "Quota d'espaces atteint — ajoutez des sièges pour en créer un nouveau.",
    addSeatsTitle: 'Ajouter des sièges',
    addSeatsDesc: 'Sélectionnez le nombre de sièges supplémentaires à ajouter à votre abonnement.',
    seatPriceLabel: 'Prix par siège',
    seatsLabel: 'Sièges',
    addSeatsConfirm: 'Ajouter',
    addSeatsSuccess: 'Sièges ajoutés avec succès !',
    confirmArchive: 'Êtes-vous sûr de vouloir archiver cet espace ? Les données seront conservées 30 jours.',
    spaceLimitReached: 'Limite d\'espaces atteinte pour votre abonnement.',
    spaceName: 'Nom de l\'espace',
    spaceCreated: 'Espace créé avec succès',
    spaceUpdated: 'Espace mis à jour',
    spaceArchived: 'Espace archivé',
    downgradeToPro: 'Repasser en compte Pro',
    downgradeTitle: 'Repasser en compte Pro',
    downgradeDescription: 'Choisissez l\'espace à conserver. Les autres espaces deviendront inaccessibles (récupérables sur demande).',
    downgradeKeepLabel: 'Espace à conserver',
    downgradeConfirm: 'Confirmer le passage en Pro',
    downgradeSuccess: 'Compte repassé en Pro',
  },

  // Réseaux sociaux et canaux
  networks: {
    x: 'X (Twitter)',
    twitter: 'X (Twitter)',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    newsletter: 'Newsletter',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    pinterest: 'Pinterest',
    reddit: 'Reddit',
    googlebusiness: 'Google Business',
    baidu: 'Baidu',
    slack: 'Slack',
    whatsapp: 'WhatsApp',
    telegram: 'Telegram',
    teams: 'Microsoft Teams',
    discord: 'Discord',
    threads: 'Threads',
    bluesky: 'Bluesky',
    other: 'Autre'
  },

  // Authentification
  auth: {
    title: 'Bon retour',
    subtitle: 'Connectez-vous à votre compte pour continuer',
    emailLabel: 'Email',
    emailPlaceholder: 'nom@exemple.com',
    passwordLabel: 'Mot de passe',
    signInButton: 'Se connecter',
    signingIn: 'Connexion en cours...',
    errorInvalid: 'Email ou mot de passe incorrect',
    loginErrorTitle: 'Échec de la connexion',
    loginErrorDescription: 'Vérifiez vos identifiants et réessayez.',
    forgotPassword: 'Mot de passe oublié ?',
    heroTitle: 'Maîtrisez votre veille stratégique avec l\'IA.',
    heroSubtitle: 'Automatisez la collecte, l\'analyse et la diffusion de vos informations stratégiques grâce à notre plateforme intelligente.',
    features: [
      'Surveillance multi-sources en temps réel',
      'Analyse sémantique avancée',
      'Génération de newsletters automatisée',
      'Tableaux de bord personnalisables'
    ],
    copyright: 'Raiso. Tous droits réservés.',
    sessionExpiredTitle: 'Session expirée',
    sessionExpiredDescription: 'Votre session a expiré. Veuillez vous reconnecter pour continuer.',
    accountDeactivatedTitle: 'Accès révoqué',
    accountDeactivatedDescription: 'Votre compte a été désactivé ou votre accès à cet espace a été révoqué. Contactez l\'agence qui vous a invité.',
    switchToSignup: 'Pas encore de compte ?',
    switchToSignupLink: 'Créer un compte',
    switchToLogin: 'Déjà un compte ?',
    switchToLoginLink: 'Se connecter',
    signupTitle: 'Créer votre compte',
    signupSubtitle: 'Choisissez votre abonnement et commencez dès maintenant',
    fullNameLabel: 'Nom complet',
    fullNamePlaceholder: 'Jean Dupont',
    nextButton: 'Continuer',
    backButton: 'Retour',
    stepAccount: 'Compte',
    stepPlan: 'Abonnement',
    stepPayment: 'Paiement',
    selectPlan: 'Choisir ce plan',
    selectedPlan: 'Plan sélectionné',
    perMonth: '/mois',
    perYear: '/an',
    billingMonthly: 'Mensuel',
    billingAnnual: 'Annuel',
    annualSavePercent: 'Économisez {percent}%',
    individualPlansTitle: 'Plans individuels',
    agencyPlansTitle: 'Plans agence',
    agencyIncludedSeats: '{n} siège(s) inclus',
    agencyExtraSeat: '{price}€/siège suppl.',
    promoCodeLabel: 'Code promo (optionnel)',
    promoCodePlaceholder: 'Entrez votre code promo',
    promoCodeApply: 'Appliquer',
    promoCodeValid: 'Code promo appliqué !',
    promoCodeInvalid: 'Code promo invalide ou expiré',
    promoCodeChecking: 'Vérification...',
    originalPrice: 'Prix initial',
    discount: 'Réduction',
    totalToPay: 'Total à payer',
    afterDiscount: 'après réduction',
    vatLabel: 'TVA (20%)',
    freeAccess: 'Accès gratuit grâce au code promo !',
    createAccountButton: 'Créer mon compte',
    createAccountAndPay: 'Créer mon compte et payer',
    redirectingToStripe: 'Redirection vers le paiement...',
    signupSuccess: 'Compte créé avec succès !',
    signupWelcome: 'Bienvenue ! Votre paiement a été validé, votre compte est prêt.',
    signupPaymentCancelled: 'Paiement annulé. Vous pourrez finaliser votre abonnement ultérieurement.',
    signupError: 'Erreur lors de la création du compte',
    emailAlreadyExists: 'Un compte existe déjà avec cette adresse email',
    passwordRuleMinLength: '8 caractères minimum',
    passwordRuleUppercase: 'Une majuscule (A-Z)',
    passwordRuleDigit: 'Un chiffre (0-9)',
    passwordRuleSpecial: 'Un caractère spécial (!@#...)',
    confirmPasswordLabel: 'Confirmer le mot de passe',
    passwordsMismatch: 'Les mots de passe ne correspondent pas.',
    passwordsMatch: 'Mots de passe identiques',
    passwordSecurityError: 'Le mot de passe ne respecte pas les critères de sécurité.',
    loadPlansError: 'Impossible de charger les plans',
    passwordMinLength: 'Le mot de passe doit contenir au moins 8 caractères',
    passwordCopied: 'Mot de passe copié',
    passwordSaveReminder: '⚠️ Notez votre mot de passe quelque part avant de passer à l\'étape suivante !',
    creditsPerMonth: 'crédits/mois',
    watermark: 'Watermark',
    referralCodeLabel: 'Code de parrainage (optionnel)',
    referralCodePlaceholder: 'Code de parrainage',
    // Pricing cards
    htLabel: 'HT',
    ttcLabel: 'TTC',
    vatAtCheckout: 'TVA calculée au paiement',
    monthShort: 'mois',
    billedAnnually: 'facturé annuellement',
    freePrice: 'Gratuit',
    mostPopular: 'LE PLUS POPULAIRE',
    perExtraClient: '/ client supplémentaire',
    // Plan taglines
    taglineFree: 'Découvrez RAISO gratuitement',
    taglinePro: 'Tout ce qu\'il faut pour un créateur solo',
    taglineAgency: 'Gérez tous vos clients depuis un seul espace',
    // Plan CTAs
    ctaFree: 'Commencer gratuitement',
    ctaPro: 'Commencer Pro',
    ctaAgency: 'Commencer Agency',
    // Free plan features
    featureFree1: '1 utilisateur',
    featureFree2: '1 réseau social connecté',
    featureFree3: 'Nombre de posts générés limité',
    featureFree4: 'Mention « via Raiso » sur vos posts',
    featureFree5: 'Fonctionnalités essentielles uniquement',
    // Pro plan features
    featurePro1: '1 marque / espace de travail',
    featurePro2: 'Tous vos réseaux sociaux connectés',
    featurePro3: 'Suivi illimité de vos sujets et sources d\'actualité',
    featurePro4: 'Posts générés en illimité',
    featurePro5: 'Calendrier de vos publications',
    featurePro6: 'Programmation et publication automatiques',
    featurePro7: 'Statistiques de performance détaillées',
    // Agency plan features
    featureAgency1: '10 sous-comptes clients',
    featureAgency2: 'Multi-marques',
    featureAgency3: 'Dashboard agence centralisé',
    featureAgency4: 'Gestion des accès',
    featureAgency5: 'Analytics par client',
    featureAgency6: 'Planification multi-comptes',
    // Email verification
    verifyEmailTitle: 'Vérifiez votre email',
    verifyEmailDescription: 'Un email de vérification a été envoyé à {email}. Cliquez sur le lien pour activer votre compte.',
    resendVerificationEmail: 'Renvoyer l\'email de vérification',
    checkSpamFolder: 'Si vous ne trouvez pas l\'email, pensez à vérifier votre dossier spam ou courriers indésirables.',
    verificationEmailResent: 'Email de vérification renvoyé !',
    verificationEmailResendError: 'Erreur lors de l\'envoi de l\'email',
    emailVerifiedSuccess: 'Email vérifié avec succès ! Vous pouvez maintenant vous connecter.',
    emailVerifiedWelcome: 'Email vérifié avec succès !',
    emailVerificationExpired: 'Le lien de vérification a expiré. Veuillez demander un nouveau lien.',
    emailVerificationInvalid: 'Le lien de vérification est invalide.',
    emailNotVerifiedError: 'Votre email n\'est pas encore vérifié. Vérifiez votre boîte de réception.',
    // Forgot / reset password
    forgotPasswordTitle: 'Mot de passe oublié ?',
    forgotPasswordSubtitle: 'Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.',
    forgotPasswordSubmit: 'Envoyer le lien',
    forgotPasswordSubmitting: 'Envoi en cours...',
    forgotPasswordEmailSent: 'Si cette adresse est associée à un compte, vous recevrez un email dans quelques minutes.',
    checkSpamWarning: 'Pensez à vérifier vos spams si vous ne recevez rien.',
    forgotPasswordBackToLogin: 'Retour à la connexion',
    resetPasswordTitle: 'Nouveau mot de passe',
    resetPasswordSubtitle: 'Choisissez un nouveau mot de passe pour votre compte.',
    resetPasswordSubmit: 'Réinitialiser le mot de passe',
    resetPasswordSubmitting: 'Réinitialisation...',
    resetPasswordSuccess: 'Mot de passe réinitialisé ! Vous pouvez maintenant vous connecter.',
    resetPasswordExpired: 'Ce lien a expiré ou est invalide. Demandez un nouveau lien.',
    resetPasswordInvalid: 'Ce lien est invalide.',
    resetPasswordError: 'Une erreur s\'est produite. Veuillez réessayer.',
    requestNewLink: 'Demander un nouveau lien',
    newPasswordLabel: 'Nouveau mot de passe',
    confirmNewPasswordLabel: 'Confirmer le nouveau mot de passe',
  },

  // Paramètres généraux
  settings: {
    title: 'Paramètres généraux',
    setupScore: 'Score de configuration',
    setupScoreLabel: 'Score de configuration',
    setupAnalyze: 'Analyser mon paramétrage',
    setupCheckPositioning: 'Positionnement défini',
    setupCheckSources: 'Au moins 1 source ajoutée',
    setupCheckChannels: 'Au moins 1 canal créé',
    setupCheckTopics: 'Au moins 1 thématique (mots-clés courts)',
    setupCheckMultipleSources: '3 sources ou plus',
    setupCheckConnectedChannel: '1 canal connecté (Zernio)',
    language: 'Langue de l\'interface',
    languageLabel: 'Langue',
    typography: 'Typographie',
    typographyPlaceholder: 'Choisir une police',
    typographyPreview: 'Aperçu de la typographie - Exemple de texte',
    colorScheme: 'Palette de couleurs',
    saveColors: 'Enregistrer les couleurs',
    resetColors: 'Réinitialiser',
    logo: 'Logo de l\'entreprise',
    logoUrl: 'URL du logo',
    logoUrlPlaceholder: 'https://...',
    saveLogo: 'Enregistrer le logo',
    uploadLogo: 'Téléverser un fichier',
    chooseFile: 'Choisir un fichier',
    uploading: 'Téléversement...',
    orUseUrl: 'ou utiliser une URL',
    logoUploaded: 'Logo téléversé avec succès',
    logoUploadError: 'Erreur lors du téléversement du logo',
    invalidLogoType: 'Type de fichier non supporté (JPEG, PNG, GIF, WebP, SVG)',
    logoTooLarge: 'Le fichier est trop volumineux (max 5MB)',
    // V4-SETTINGS-01 2026-05-29 — Tooltip sections brand locked
    brandLockedTooltip: 'Configurez votre positionnement pour débloquer cette section.',
    locked: 'Verrouillé',
    // V4-FRONT-WIZARD-POST-GEN-HIDE 2026-05-29 — Toggle tutoriel d'onboarding
    onboardingToggleLabel: 'Afficher le tutoriel d\'onboarding',
    onboardingToggleDescription: 'Réafficher le guide des 4 étapes (Positionnement, Thématiques, Sources, Canaux) au-dessus de la galerie de posts.',
  },

  // Personnalisation
  customization: {
    colorPickerDescription: 'Sélectionner une couleur personnalisée',
  },

  // Sources
  sources: {
    freePlan: 'Plan Free',
    upgradeToReactivate: 'Passez en Pro pour réactiver cette source',
    title: 'Sources',
    titleTooltip: 'Les sources sont les flux que Raiso surveille (RSS, sites web, chaînes YouTube) pour alimenter votre veille et générer du contenu basé sur l\'actualité de vos thématiques.',
    add: 'Créer votre première source',
    suggestButton: 'Générer des sources',
    suggestTitle: 'Suggérer des sources de veille',
    suggestDescription: 'Basé sur votre positionnement et vos thématiques, voici des sources que nous vous proposons. Décochez celles qui ne vous intéressent pas.',
    suggestLoading: 'Génération en cours…',
    suggestEmpty: 'Aucune suggestion disponible.',
    suggestError: 'Impossible de générer des suggestions de sources.',
    suggestErrorAdd: 'Erreur lors de l\'ajout des sources',
    suggestSuccess: '{count} source(s) ajoutée(s)',
    suggestAdding: 'Ajout de {count} source(s) en cours…',
    emptyTitle: 'Aucune source de veille',
    emptyDescription: 'Ajoutez des flux RSS, sites web ou chaînes YouTube pour alimenter votre veille. L\'IA peut aussi en suggérer.',
    // V4-WATCH-KEYWORDS-i18n 2026-05-29 — vocabulaire "Veille".
    suggestNoTopics: "Ajoutez d'abord une thématique pour activer la suggestion IA",
    none: 'Aucune source configurée',
    name: 'Nom de la source',
    url: 'URL',
    type: 'Type',
    keywords: 'Mots-clés',
    keywordsPlaceholder: 'Séparez les mots-clés par des virgules',
    enabled: 'Activé',
    lastSync: 'Dernière synchronisation',
    suggestedSources: 'Sources suggérées',
    suggestedSourcesDescription: 'Sources extraites automatiquement à partir de vos thématiques',
    acceptSuggestion: 'Accepter',
    rejectSuggestion: 'Rejeter',
    deleteSuggestion: 'Supprimer cette suggestion',
    newSource: 'Nouvelle source',
    newKeyword: 'Nouveau mot-clé',
    exampleName: 'Ex: TechCrunch',
    validateSource: 'Valider cette source',
    deleteSuggestionTitle: 'Supprimer cette suggestion',
    previewSource: 'Prévisualiser cette source',
    tutorialTitle: 'Tutoriel Youtube',
    tutorialDescription: 'Apprenez à ajouter des sources à partir de vidéos Youtube.',
    deleteSourceTitle: 'Supprimer cette source ?',
    deleteSourceDescription: 'Êtes-vous sûr de vouloir supprimer "{title}" ? Cette action est irréversible.',
    recommend: 'Recommander',
    recommendedSources: 'Exemples de sources',
    defineInterestsFirst: 'Veuillez d\'abord définir vos thématiques',
    examplesDescription: 'Ces sources sont des exemples pour vous inspirer. Cliquez sur ✓ pour les ajouter ou sur la corbeille pour les ignorer.',
    examplesNote: '💡 Ces suggestions sont des exemples basés sur vos thématiques. Personnalisez-les selon vos besoins.',
    youtubeIdHelp: 'L\'ID de la chaîne YouTube commence par "UC" suivi de 22 caractères. Vous pouvez le trouver dans l\'URL de la chaîne ou dans le code source de la page.',
    youtubeIdInvalid: 'Format d\'ID YouTube invalide. L\'ID doit commencer par "UC" suivi de 22 caractères alphanumériques.',
    urlInvalid: 'Format d\'URL invalide. L\'adresse doit commencer par http:// ou https://.',
    validatingSource: 'Vérification de la source...',
    sourceValidationFailed: 'Impossible d\'accéder à cette source. Vérifiez l\'URL ou l\'ID.',
    sourceValidationSuccess: 'Source accessible !',
    refreshSource: 'Rafraîchir la source',
    syncAll: 'Tout synchroniser',
    // Multi-agent generation source traceability
    usedForGeneration: 'Sources utilisées pour la génération',
    relevance: 'Pertinence',
    sourceDetails: 'Détails de la source',
    keyFacts: 'Faits clés extraits',
    relevanceHigh: 'Élevée',
    relevanceMedium: 'Moyenne',
    relevanceLow: 'Faible',
    relevanceTooltip: 'Correspondance estimée entre cet article et votre positionnement + vos centres d\'intérêt. Plus le score est élevé, plus l\'article colle à votre ligne éditoriale.',
    staleWarning: '{count} source(s) non synchronisée(s) depuis plus de 7 jours',
    syncProgress: 'Synchronisation en cours ({count})',
    aiSummary: 'Résumé IA',
    postAngles: 'Angles éditoriaux',
    entities: 'Entités mentionnées',
    extractedKeywords: 'Mots-clés extraits',
    feedItems: 'Éléments collectés',
    feedItemsDescription: 'Liste des éléments collectés pour cette source',
    // V4-FEEDITEMS-FILTERS-REDESIGN 2026-07-30 — libellés des filtres (étaient en dur)
    filterScore: 'Score',
    filterDate: 'Depuis…',
    filterMinScore: 'Score minimum',
    filterAnyScore: 'Tous',
    resetFilters: 'Tout réinitialiser',
    viewItems: 'Consulter',
    noItems: 'Aucun élément trouvé',
    itemCountTooltip: '{count} élément(s) collecté(s)',
    // V4-SOURCE-ERROR-NO-DIAGNOSTIC — statuts de synchro (étaient codés en anglais en dur)
    syncStatusPending: 'Synchronisation…',
    syncStatusSuccess: 'Synchronisée',
    syncStatusFailed: 'Échec',
    // Messages actionnables par code (cf. src/utils/sourceSyncError.ts)
    syncErrorEmptyContent: 'La source a répondu, mais sans contenu exploitable : page vide, protection anti-bot, ou transcript indisponible. Ouvre l’URL dans un navigateur pour vérifier qu’elle affiche bien du texte.',
    syncErrorChannelNotFound: 'Chaîne YouTube introuvable : elle a été supprimée ou rendue privée. La source a été désactivée automatiquement.',
    syncErrorUrlNotAllowed: 'Cette URL a été refusée pour raisons de sécurité (adresse interne, protocole non autorisé, ou domaine bloqué). Utilise une URL publique en http(s).',
    syncErrorUnknown: 'La dernière synchronisation a échoué pour une raison inattendue. Réessaie ; si l’échec persiste, transmets le détail technique au support.',
    syncErrorDetail: 'Détail technique',
    syncErrorRetryHint: 'Utilise le bouton de synchronisation pour réessayer.',
    aiAnalyzed: 'Analysé par IA',
    qualityScore: 'Score de qualité',
    keyPoints: 'Points clés',
    viewpoints: 'Points de vue',
    confidence: 'confiance',
    targetAudience: 'Cible',
    sourceContext: 'Source',
    risksGuardrails: 'Risques & garde-fous',
    maxReached: 'Limite de sources atteinte. Passez à un abonnement supérieur.',
    // V4-SOURCES-I18N-LABELS 2026-05-29 — FINDING-SOURCES-01 : labels d'URL i18n
    rssFeedUrl: 'URL du flux RSS',
    youtubeChannelId: 'ID de la chaîne (canonique)',
    podcastUrl: 'URL du podcast',
    rawTextLabel: 'Contenu',
    urlLabel: 'URL',
    // V4-SOURCES-CTA-CREATE 2026-05-29 — FINDING-CHANNELS-01
    createCTA: 'Créer',
    types: {
      RSS: 'RSS',
      API: 'API',
      'Web Scraper': 'Web Scraper',
      Manuel: 'Manuel',
    },
  },

  // Veille
  watch: {
    // V4-FRONT-NAMING-THEMATIQUES-FROZEN 2026-06-22 — Nom DÉFINITIF : "Thématiques" (FR) / "Topics" (EN) / "Temáticas" (ES).
    // Historique : Veille → Centres d'intérêt → Thématiques (3e renommage — ne pas changer à nouveau sans décision produit formalisée).
    title: 'Thématiques',
    add: 'Nouvelle thématique',
    none: 'Aucune thématique configurée. Créez votre première thématique pour commencer.',
    suggestButton: 'Générer des mots-clés',
    suggestTitle: 'Suggérer des thématiques',
    suggestDescription: 'Basé sur votre positionnement, voici des thématiques que nous vous proposons de surveiller. Décochez celles qui ne vous intéressent pas.',
    suggestLoading: 'Génération en cours…',
    suggestEmpty: 'Aucune suggestion disponible.',
    suggestError: 'Impossible de générer des suggestions. Vérifiez votre positionnement.',
    suggestErrorAdd: 'Erreur lors de l\'ajout des thématiques',
    suggestSuccess: '{count} thématique(s) ajoutée(s)',
    suggestAdding: 'Ajout de {count} thématique(s) en cours…',
    emptyTitle: 'Aucune thématique',
    emptyDescription: 'Commencez par décrire les sujets que vous voulez surveiller. L\'IA peut aussi en suggérer à partir de votre positionnement.',
    // Nouveaux champs titre/description
    topicTitle: 'Titre',
    topicTitlePlaceholder: 'Ex: Veille Intelligence Artificielle',
    topicTitleTooltip: 'Un titre court et descriptif pour identifier facilement cette thématique.',
    description: 'Description',
    descriptionPlaceholder: 'Ex : IA générative B2B, agents IA, LLM open source — 3 à 8 thèmes ou mots-clés',
    descriptionTooltip: 'Décrivez ce que vous souhaitez surveiller en mots-clés ou thèmes courts. Évitez les phrases longues.',
    // Anciens champs conservés pour compatibilité
    prompt: 'Description',
    promptPlaceholder: 'Ex : IA générative, LLMs, agents IA...',
    keywords: 'Mots-clés',
    keywordsPlaceholder: 'Ex: ChatGPT, Claude, LLM, IA générative',
    keywordsTooltip: 'Ajoutez des mots-clés spécifiques pour affiner la veille. Ces termes seront utilisés pour filtrer et prioriser le contenu.',
    enabled: 'Activé',
    createdDate: 'Date de création',
    deleteTitle: 'Supprimer cette thématique ?',
    deleteDescription: 'Cette action est irréversible. La thématique et ses mots-clés seront définitivement supprimés.',
    newKeyword: 'Nouveau mot-clé',
    generatingKeywords: 'Génération des mots-clés par l\'IA...',
    keywordsGenerated: '💡 Les mots-clés sont générés automatiquement par l\'IA à la création',
    keywordWarningChars: 'Évitez les virgules et points — utilisez des mots simples',
    keywordsGenerating: 'Génération des mots-clés en cours…',
    generateViaAI: 'Générer des mots-clés',
    webSearchItems: 'Résultats de recherche web',
    webSearchItemsTooltip: '{count} résultat(s) web collecté(s) lors des générations',
    viewItems: 'Consulter',
    noItems: 'Aucun résultat web trouvé',
  },

  // Positionnement
  positioning: {
    title: 'Positionnement général',
    description: 'Définissez votre positionnement global',
    prompt: 'Prompt système',
    promptPlaceholder: 'Décrivez votre positionnement, ton, valeurs...',
    improve: 'Améliorer',
    save: 'Enregistrer',
    modeChat: 'Agent',
    modeText: 'Texte',
    modeBrandConfig: 'Charte graphique',
    modeBrandConfigShort: 'Charte',
    modeToggleLabel: 'Mode',
    chatPlaceholder: 'Écris ta réponse...',
    // Chat conversation messages
    chatInitialMessage: 'Bonjour, je vais t\'accompagner dans la formulation de ton positionnement pour aider nos agents à générer du contenu vraiment personnalisé. Pour commencer, peux-tu me dire si tu utilises ce service à titre personnel ou pour le compte d\'une entreprise ?',
    chatInitialMessageExisting: 'Bonjour ! Votre positionnement est déjà configuré. Je peux l\'améliorer, l\'affiner ou l\'enrichir. Que souhaitez-vous modifier ?',
    chatQuestionPersonal: 'Super ! Et quel est ton domaine d\'activité ou d\'intérêt principal ?',
    chatQuestionCompany: 'Parfait ! Quel est le nom de ton entreprise et dans quel secteur d\'activité opère-t-elle ?',
    chatQuestionTone: 'Intéressant ! Maintenant, comment décrirais-tu le ton que tu souhaites pour ton contenu ? Plutôt formel et professionnel, ou décontracté et accessible ?',
    chatQuestionValues: 'Excellent choix ! Peux-tu me donner 3 valeurs ou messages clés que tu souhaites véhiculer dans tes contenus ?',
    chatQuestionAudience: 'Parfait ! Dernière question : qui est ton audience cible ? Décris-moi le profil type de tes lecteurs.',
    chatFinalMessage: 'Merci pour toutes ces informations ! Je vais maintenant générer un positionnement personnalisé basé sur tes réponses. Tu pourras toujours le modifier depuis le mode texte en haut à droite de cette page.',
    chatTypePersonal: 'Personnel',
    chatTypeCompany: 'Entreprise',
    // New features
    importFromUrl: 'Importer depuis un lien',
    extracting: 'Extraction en cours...',
    extract: 'Extraire',
    extractedInfo: 'Informations extraites',
    analyzeStyle: 'Analyser le style',
    analyzeStyleButton: 'Analyser le style',
    analyzing: 'Analyse en cours...',
    styleAnalysis: 'Analyse du style',
    pastePostsHere: 'Collez vos posts exemples ici, séparés par ----',
    suggestChanges: 'Demander une modification...',
    suggesting: 'Suggestion en cours...',
    accept: 'Accepter',
    reject: 'Refuser',
    modify: 'Modifier',
    history: 'Historique',
    historyTitle: 'Historique des versions',
    sendMessage: 'Envoyer le message',
    versions: 'Versions',
    noVersions: 'Aucune version antérieure',
    restore: 'Restaurer',
    templateInfo: 'C\'est un template par défaut. Remplissez les champs [entre crochets] et cochez les options.',
    clickToEdit: 'Cliquer pour éditer le texte',
    changesApplied: 'Modifications appliquées',
    versionRestored: 'Version restaurée',
    // Toolbar buttons
    importUrl: 'Importer URL',
    reset: 'Réinitialiser',
    // Reset dialog
    resetTitle: 'Réinitialiser le positionnement',
    resetConfirm: 'Êtes-vous sûr de vouloir réinitialiser votre positionnement au template par défaut ?',
    warning: 'Attention',
    resetWarning: 'Si vous ne personnalisez pas le template après cette action, la qualité des prochains posts générés sera significativement réduite.',
    resetNote: 'Votre positionnement actuel sera sauvegardé dans l\'historique des versions.',
    // AI suggestion
    aiSuggestionPlaceholder: 'Demander une modification à l\'IA...',
    // Chat mode banner
    chatModeInfo: 'Mode conseil — Discutez de votre positionnement sans modifier le template. Pour appliquer des changements, passez en mode Texte.',
    chatModeSubtitle: 'Posez vos questions ou demandez des conseils. Ce chat est consultatif.',
    // Apply from chat
    applyThisPositioning: 'Appliquer ce positionnement',
    positioningApplied: 'Positionnement appliqué avec succès',
    applyError: 'Erreur lors de l\'application du positionnement',
    // Apply suggestion with diff
    applySuggestion: 'Appliquer ces modifications',
    discardSuggestion: 'Continuer sans appliquer',
    suggestionReady: 'Modifications prêtes - vérifiez et validez',
    noSuggestion: 'Aucune modification suggérée',
    suggestionError: 'Erreur lors de la génération des modifications',
    generatingChanges: 'Génération...',
    // DiffView
    accepted: 'acceptés',
    unifiedView: 'Unifié',
    splitView: 'Côte à côte',
    clickToReview: 'Cliquez sur ✓ ou ✗ pour chaque ligne',
    beforeLabel: 'Avant',
    expectedResult: 'Résultat (prévu)',
  },

  // Setup Wizard
  // V4-UX-SETUP-EXPRESS 2026-07-02 (Phase 1.1) — Onboarding express depuis l'URL.
  setupExpress: {
    title: 'Configurez Raiso en 2 minutes',
    subtitle: "Donnez-nous l'adresse de votre site : on analyse votre activité, puis on prépare automatiquement vos thématiques de veille et vos sources.",
    subtitlePositioningDone: 'Votre positionnement est prêt. On prépare automatiquement vos thématiques de veille et vos sources.',
    agencyContext: 'Configuration de l\'espace « {spaceName} ».',
    urlLabel: 'Adresse de votre site web',
    urlPlaceholder: 'https://mon-entreprise.com',
    urlInvalid: "L'adresse de votre site semble invalide. Vérifiez-la ou configurez manuellement.",
    // V4-ONBOARDING-PERSONAL-BRANDING
    sourceModeWebsite: "J'ai un site web",
    sourceModePersonal: 'Personal branding',
    personalPostsLabel: 'Collez 3 à 5 de vos publications',
    personalPostsPlaceholder: 'Collez ici vos posts, séparés par une ligne vide entre chacun…',
    personalPostsHint: 'On analyse votre style et vos thèmes pour construire votre positionnement.',
    postsInvalid: 'Collez au moins 2 publications, séparées par une ligne vide.',
    sectorWatchLabel: "Je m'appuie sur l'actualité de mon secteur",
    sectorWatchHint: 'Si activé, on crée des thématiques de veille et des sources. Sinon, on se base uniquement sur votre style.',
    stateNotNeeded: 'Non nécessaire pour votre profil',
    importPostsCta: 'Importer mes derniers posts',
    importPostsDone: '{count} publications importées.',
    importPostsEmpty: 'Aucun post à importer. Collez vos publications manuellement.',
    start: 'Configurer automatiquement',
    manualLink: 'Je préfère configurer manuellement',
    runningTitle: 'Préparation de votre espace…',
    runningSubtitle: 'Cela prend moins d\'une minute.',
    stepPositioning: 'Analyse de votre activité',
    stepTopics: 'Thématiques de veille',
    stepSources: 'Sources de contenu',
    stateRunning: 'En cours…',
    stateDone: 'Terminé',
    stateSkipped: 'Déjà configuré',
    stateFailed: 'À compléter manuellement',
    topicsCreated: '{count} thématiques ajoutées',
    sourcesCreated: '{count} sources ajoutées',
    extractFailedTitle: "On n'a pas pu analyser votre site",
    extractFailedDesc: 'Le site est peut-être protégé ou trop lent. Configurons votre positionnement ensemble, étape par étape.',
    goManual: 'Configuration guidée',
    retry: 'Réessayer avec une autre adresse',
    doneTitle: 'Votre espace est prêt !',
    doneSubtitle: 'Dernière étape : connectez un réseau social pour générer et publier vos premiers posts.',
    doneSubtitleChannel: 'Vous pouvez générer vos premiers posts dès maintenant.',
    doneSubtitleNoChannel: 'Connectez un réseau social pour générer puis publier vos posts.',
    ctaGenerate: 'Générer mes premiers posts',
    ctaConnectChannel: 'Connecter un réseau social',
    noChannelWarning: "Vous ne pourrez pas publier tant qu'un réseau n'est pas connecté à votre compte.",
    reviewSetup: 'Voir / ajuster ma configuration',
    incompleteTitle: 'Configuration incomplète',
    incompleteDesc: "Certaines étapes n'ont pas abouti. Relancez la configuration automatique ou complétez-les manuellement.",
    retryAuto: 'Relancer la configuration automatique',
    addTopicsManually: 'Ajouter mes thématiques manuellement',
    addSourcesManually: 'Ajouter mes sources manuellement',
  },
  setupWizard: {
    title: 'Bienvenue sur Raiso !',
    subtitle: 'Pour obtenir des publications de qualité, Raiso a besoin d\'un peu de contexte. Configurez ces 4 éléments essentiels pour commencer :',
    progressLabel: '{completed}/{total} étapes complétées',
    stepPositioning: 'Positionnement',
    stepPositioningDesc: 'Définissez votre identité, votre ton et votre cible.',
    stepWatch: 'Thématiques',
    stepWatchDesc: 'Indiquez les thématiques sur lesquelles vous souhaitez communiquer.',
    stepSources: 'Sources',
    stepSourcesDesc: 'Ajoutez des flux RSS, sites web ou chaînes YouTube à surveiller.',
    stepChannels: 'Canaux',
    stepChannelsDesc: 'Configurez au moins un canal de communication (ex: LinkedIn, X).',
    buttonConfigure: 'Configurer',
    buttonCompleted: 'Terminé',
    completedTitle: 'Tout est prêt ! 🎉',
    completedSubtitle: 'Votre espace de travail est configuré. Vous pouvez maintenant générer vos premiers posts.',
    buttonStart: 'Commencer à générer',
    // Backlog UX 19-05 — lock séquentiel des steps
    lockedStepBadge: 'Verrouillé',
    lockedStepTooltip: 'Complétez d\'abord l\'étape "{previousTitle}" pour débloquer celle-ci.',
    lockedStepDescription: 'Disponible après l\'étape précédente.',
    // V4-5 — CTA charte graphique en fin de wizard
    // V4-WIZARD-04 2026-05-29 — vouvoiement pour cohérence ton "Vous" du produit
    brandConfigCtaTitle: '🎨 Vos couleurs et polices, pour des carrousels et images cohérents',
    brandConfigCtaDesc: 'Définissez votre palette, vos polices et votre logo : vos carrousels et images générés par l\'IA les reprennent automatiquement pour rester fidèles à votre marque. Extraits de votre site ou saisis à la main. C\'est optionnel — vous pouvez déjà générer des posts sans charte.',
    brandConfigCtaButton: 'Configurer',
    // V4-WIZARD-02 2026-05-29 — CTA fin de wizard (réutilise buttonStart si déjà présent)
    startCTA: 'Commencer à générer des posts',
    // V4-WIZARD-AGENCY-CONTEXT 2026-06-18 — encart en tête du wizard pour les comptes
    // agence : clarifie DE QUI on configure le positionnement (l'espace = un client).
    agencyContextTitle: '👥 Espace client',
    agencyContextDesc: 'Vous configurez l\'espace « {spaceName} ». Le positionnement, les thématiques et les sources ci-dessous s\'appliquent à ce client.',
  },

  // V4-ONBOARDING-TOUR 2026-06-18 — bulles explicatives du tour produit (react-joyride).
  tour: {
    // Boutons de navigation
    back: 'Précédent',
    close: 'Fermer',
    last: 'Terminer',
    next: 'Suivant',
    skip: 'Passer',
    // Étapes (parcours agence)
    spaceSwitcherTitle: 'Vos espaces clients',
    spaceSwitcherDesc: 'Chaque espace correspond à un de vos clients. Changez d\'espace ici pour configurer et publier pour le bon client.',
    spacesManageTitle: 'Gérer vos espaces',
    spacesManageDesc: 'Créez, renommez ou archivez vos espaces ici, et invitez vos clients en lecture seule.',
    // Étapes communes
    positioningTitle: 'Positionnement',
    positioningDesc: 'Définissez votre identité, votre ton et votre cible. C\'est la base de tout ce que Raiso génère.',
    watchTitle: 'Thématiques',
    watchDesc: 'Indiquez les thématiques sur lesquelles vous souhaitez communiquer : Raiso surveille l\'actualité associée.',
    sourcesTitle: 'Sources',
    sourcesDesc: 'Ajoutez des flux RSS, sites ou chaînes YouTube : Raiso s\'en inspire pour générer des posts pertinents.',
    channelsTitle: 'Canaux',
    channelsDesc: 'Connectez vos réseaux (LinkedIn, X, Instagram…) pour publier directement depuis Raiso.',
    engagementTitle: 'Engagement',
    engagementDesc: 'Retrouvez ici les commentaires reçus sur vos publications pour y répondre.',
    generateTitle: 'Générer des posts',
    generateDesc: 'Une fois la configuration prête, lancez la génération de posts ici. Vous pourrez les relire, éditer et publier.',
  },

  // Onboarding - Flux de questions guidées
  onboarding: {
    // Tooltips séquentiels (chantier C 2026-05) — verrouillage des items Sidebar
    lockedTooltip: "Terminez d'abord cette étape pour continuer",
    // V4-NAMING-VEILLE 2026-05-29 — alignement vocabulaire "Veille".
    lockedTopicsTooltip: "Définissez d'abord votre positionnement pour débloquer la veille",
    // V4-WATCH-KEYWORDS-i18n 2026-05-29 — vocabulaire "Veille".
    lockedSourcesTooltip: "Ajoutez au moins une thématique pour débloquer les sources",
    lockedChannelsTooltip: "Ajoutez au moins une source pour débloquer les canaux de communication",
    lockedPostsTooltip: "Connectez au moins un canal pour débloquer la galerie de publications",
    // V4-SIDEBAR-LOCK-NO-POST 2026-05-28 — Analytics / Engagement / Publications requièrent ≥1 post
    lockedAnalyticsTooltip: "Générez votre premier post pour débloquer les analytics",
    lockedEngagementTooltip: "Générez votre premier post pour débloquer l'engagement (commentaires)",
    lockedPublicationsTooltip: "Générez votre premier post pour débloquer la file d'attente de publications",
    comingSoonTooltip: "Cette fonctionnalité sera disponible prochainement",
    readOnlyTooltip: "Vous consultez ce space en lecture seule",
    // Phase 1.4 — widget de progression global persistant (OnboardingProgressWidget)
    setupProgress: {
      title: "Votre configuration",
      resumePrefix: "Reprenez à",
      continueBtn: "Continuer",
      expand: "Afficher la progression",
      stepPositioning: "Positionnement",
      stepTopics: "Thématiques",
      stepSources: "Sources",
      stepChannels: "Canaux",
      optional: "optionnel",
      reopenAssistant: "Rouvrir l'assistant",
      dragHint: "Glissez pour déplacer",
    },
    // Messages des étapes
    steps: {
      welcome: {
        message: "Bonjour ! 👋 Je suis ton assistant de positionnement. Je vais te poser quelques questions pour créer un profil personnalisé qui permettra à Raiso de générer du contenu vraiment adapté à ton style.\n\nC'est parti ?",
        startButton: "C'est parti !",
      },
      usageType: {
        message: "Parfait ! Pour commencer, tu utilises ce service à quel titre ?",
        personal: "👤 À titre personnel",
        company: "🏢 Pour une entreprise",
        custom: "✏️ Définir moi-même",
      },
      companyUrl: {
        message: "Super ! Pour mieux comprendre ton entreprise, as-tu un site web ? Je peux analyser ta page d'accueil ou ta page \"À propos\" pour extraire automatiquement les informations clés.",
        hasUrl: "🔗 Oui, je donne l'URL",
        noUrl: "✏️ Non, je décris manuellement",
        placeholder: "https://www.monentreprise.com",
      },
      companyName: {
        message: "Pas de problème ! Peux-tu me donner le nom de ton entreprise et décrire brièvement son activité ?",
        placeholder: "Ex: 3615 Future est un cabinet de conseil en IA qui accompagne les entreprises dans leur transformation digitale.",
      },
      personalDomain: {
        message: "D'accord ! Quel est ton domaine d'activité ou d'expertise principal ? Ça m'aidera à personnaliser ton positionnement.",
        placeholder: "Ex: Marketing digital, Développement web, Coaching...",
      },
      purpose: {
        message: "Très bien ! Maintenant, quel est ton objectif principal sur les réseaux sociaux ?",
        brandAwareness: "📢 Développer ma notoriété",
        thoughtLeadership: "💡 Partager mon expertise",
        leadGeneration: "🎯 Générer des leads",
        community: "🤝 Animer ma communauté",
        recruitment: "👥 Recruter / Marque employeur",
        other: "✨ Autre objectif",
      },
      tone: {
        message: "Excellent ! Comment souhaites-tu que tes contenus soient perçus ? Choisis le ton qui te correspond le mieux.",
        professional: "👔 Professionnel et expert",
        friendly: "😊 Amical et accessible",
        inspiring: "✨ Inspirant et motivant",
        provocative: "🔥 Provocateur et disruptif",
        educational: "📚 Pédagogue et informatif",
        humorous: "😄 Humoristique et léger",
        custom: "✏️ Définir moi-même",
      },
      values: {
        message: "Parfait ! Quelles sont les 3 valeurs ou messages clés que tu veux véhiculer dans tes contenus ?\n\nTu peux les séparer par des virgules.",
        placeholder: "Ex: Innovation, Authenticité, Excellence client",
      },
      audience: {
        message: "Dernière question ! Qui est ton audience cible ? Décris-moi le profil type des personnes que tu veux toucher.",
        placeholder: "Ex: Dirigeants de PME tech, 35-55 ans, intéressés par l'innovation et la transformation digitale",
      },
      summary: {
        message: "Merci pour toutes ces informations ! 🎉\n\nVoici ce que j'ai compris:\n{summary}\n\nJe vais maintenant générer ton positionnement personnalisé. Tu pourras toujours le modifier ensuite depuis le mode texte en haut à droite de cette page.",
        confirm: "Générer mon positionnement",
        restart: "Recommencer",
      },
      complete: {
        message: "✅ Ton positionnement a été généré avec succès !\n\nTu peux le consulter et le modifier depuis le mode texte en haut à droite de cette page. Raiso utilisera désormais ces informations pour créer du contenu personnalisé.",
      },
    },
    // Labels du résumé
    summaryLabels: {
      usage: "Utilisation",
      usagePersonal: "Personnelle",
      usageCompany: "Entreprise",
      company: "Entreprise",
      domain: "Domaine",
      companyDetected: "Entreprise (détectée)",
      sector: "Secteur",
      purpose: "Objectif",
      tone: "Ton",
      values: "Valeurs",
      audience: "Audience",
    },
    // Labels des objectifs
    purposeLabels: {
      brand_awareness: "Développer ma notoriété",
      thought_leadership: "Partager mon expertise",
      lead_generation: "Générer des leads",
      community: "Animer ma communauté",
      recruitment: "Recruter / Marque employeur",
      other: "Autre",
    },
    // Labels des tons
    toneLabels: {
      professional: "Professionnel et expert",
      friendly: "Amical et accessible",
      inspiring: "Inspirant et motivant",
      provocative: "Provocateur et disruptif",
      educational: "Pédagogue et informatif",
      humorous: "Humoristique et léger",
    },
    // Checklist de progression
    checklist: {
      progression: "Progression",
      usageType: "Type d'utilisation",
      identityCompany: "Entreprise",
      identityPersonal: "Domaine d'activité",
      purpose: "Objectif",
      tone: "Ton",
      values: "Valeurs",
      audience: "Audience",
      personal: "Personnel",
      company: "Entreprise",
    },
    // Labels courts pour la checklist
    checklistShort: {
      brand_awareness: "Notoriété",
      thought_leadership: "Expertise",
      lead_generation: "Leads",
      community: "Communauté",
      recruitment: "Recrutement",
      other: "Autre",
      professional: "Pro",
      friendly: "Amical",
      inspiring: "Inspirant",
      provocative: "Provocateur",
      educational: "Pédagogue",
      humorous: "Humoristique",
    },
    // Messages de génération
    generating: "✨ Je génère votre positionnement personnalisé...",
    generationSuccess: "✅ Positionnement généré avec succès !",
    generationError: "❌ Erreur lors de la génération du positionnement",
    urlAnalyzing: "🔍 Analyse de l'URL en cours...",
    urlSuccess: "✅ Informations extraites avec succès !",
    urlError: "❌ Impossible d'analyser cette URL",
    urlErrorContinue: "⚠️ Je n'ai pas pu analyser ce site. Pas de souci, continuons avec les informations que vous me donnerez !",
    urlInvalid: "⚠️ Format d'URL invalide. Entrez le nom et l'activité de votre entreprise manuellement.",
    restartOnboarding: "Recommencer l'assistant",
    describeGoal: "Décrivez votre objectif...",
  },

  // Canaux de communication
  channels: {
    connect: 'Connecter',
    create: 'Créer',
    myAccountPrefix: 'Mon ',
    accountPrefix: 'Compte ',
    alreadyConnected: 'déjà connecté',
    noPositioning: 'Positionnement spécifique non défini',
    noPositioningTooltip: 'Ce canal utilisera le positionnement général. Tu peux affiner un positionnement dédié à ce réseau pour des posts mieux adaptés.',
    upgradeToReactivate: 'Passez en Pro pour réactiver ce canal',
    title: 'Canaux de communication',
    add: 'Créer votre premier canal',
    none: 'Aucun canal configuré',
    emptyTitle: 'Aucun canal de communication',
    emptyDescription: 'Connectez LinkedIn, X, Instagram, Slack ou un autre canal pour publier votre contenu.',
    customName: 'Nom du canal',
    customNamePlaceholder: 'Ex: Mon compte LinkedIn Pro',
    network: 'Réseau social',
    messagingPlatform: 'Plateforme de messagerie',
    profileName: 'Nom du profil',
    profileNamePlaceholder: 'Ex: @monentreprise',
    groupName: 'Nom du groupe/canal',
    groupNamePlaceholder: 'Ex: Équipe Marketing',
    profileUrl: 'URL du profil',
    profileUrlPlaceholder: 'https://...',
    apiKey: 'Clé API (optionnel)',
    apiKeyPlaceholder: 'Clé API pour automatisation',
    webhookUrl: 'Webhook URL (optionnel)',
    webhookUrlPlaceholder: 'https://hooks.slack.com/...',
    positioning: 'Positionnement spécifique (optionnel)',
    positioningPlaceholder: 'Décrivez le positionnement spécifique sur ce réseau...',
    dateFrom: 'Date de début pour les sources',
    dateFromHelp: 'Les sources web seront filtrées à partir de cette date',
    imageProvider: 'Provider de génération d\'images',
    imageProviderHelp: 'Provider utilisé pour générer les images de ce canal',
    customNameLabel: 'Nom personnalisé',
    customNameEdit: 'Ex: Mon entreprise',
    languages: 'Langues de communication',
    languagesLabel: 'Langues',
    deleteConfirm: 'Supprimer ce canal ?',
    deleteDescription: 'Êtes-vous sûr de vouloir supprimer le canal',
    deleteDescriptionFull: 'sur {network} ? Cette action est irréversible.',
    deleteAction: 'Cette action est irréversible.',
    newChannel: 'Nouveau canal',
    channelType: 'Type de canal',
    external: 'Externe (Réseaux sociaux)',
    internal: 'Interne (Messagerie)',
    externalChannels: 'CANAUX EXTERNES',
    internalChannels: 'CANAUX INTERNES',
    improveWithAI: 'Améliorer le positionnement',
    improvingPositioning: 'Génération en cours...',
    positioningImproved: 'Positionnement généré avec succès',
    profileUrlDisabled: 'Fonctionnalité bientôt disponible',
    apiKeyDisabled: 'Fonctionnalité bientôt disponible',
    oauthDisabled: 'Connexion OAuth bientôt disponible',
    post: 'post',
    posts: 'posts',
    postCountTooltip: '{count} post(s) généré(s) pour ce canal',
    positioningGlobalRequired: 'Veuillez d\'abord définir un positionnement global dans les paramètres de votre espace.',
    positioningError: 'Erreur lors de la génération du positionnement.',
    automatable: 'Automatisable',
    manualOnly: 'Manuel',
    // V4-CHANNELS-MEDIA-CAPABILITIES — formats média publiables via Zernio par réseau
    capabilitiesLabel: 'Formats publiables',
    capImages: 'Images',
    capCarousel: 'Carrousels',
    capVideo: 'Vidéo',
    capGif: 'GIF',
    capNone: 'Texte seul',
    maxReached: 'Limite de canaux atteinte. Passez à un abonnement supérieur.',
    reactivateLimitReached: 'Limite atteinte — passez en Pro pour réactiver ce canal',
    downgradeBanner: 'Certains canaux ont été désactivés suite au passage en Plan Free. Passez en Pro pour les réactiver tous.',
    // V4-CHANNELS-PENDING-SKELETON 2026-05-29 — FINDING-CHANNELS-02
    creatingChannel: 'Création du canal en cours…',
  },
  newsletter: {
    title: 'Configuration Newsletter',
    description: 'Personnalisez votre newsletter',
    template: 'Template de newsletter',
    templatePlaceholder: 'Décrivez le format et le style de votre newsletter...',
    generate: 'Générer une newsletter',
    filterByChannels: 'Filtrer par canaux',
    allChannels: 'Tous les canaux',
    save: 'Enregistrer',
    send: 'Envoyer',
    sendNewsletter: 'Envoyer la newsletter',
    selectDate: 'Sélectionner une date',
    cancel: 'Annuler',
    validate: 'Valider',
    scheduledFor: 'Programmée pour',
    addImage: 'Ajouter une image',
    replaceImage: 'Remplacer l\'image',
    generateImage: 'Générer avec l\'IA',
    generatingImage: 'Génération en cours...',
    selectStyle: 'Choisir un style',
    imageGenerated: 'Image générée avec succès',
    imageGenerationError: 'Erreur lors de la génération',
    uploadImage: 'Téléverser une image',
    orGenerateWithAI: 'ou générer avec l\'IA',
    edit: 'Modifier',
    copy: 'Copier',
    improveWithAi: 'Améliorer le texte',
    improving: 'Amélioration...',
    improveDialogTitle: 'Améliorer avec l\'IA',
    improveDialogDescription: 'Décrivez comment vous souhaitez améliorer ce post',
    improveInstructionsPlaceholder: 'Ex: Rends le plus percutant, ajoute des emojis...',
    improveButton: 'Améliorer',
    improveSuggestions: {
      moreConcise: 'Plus concis',
      moreEngaging: 'Plus engageant',
      addHook: 'Ajouter un hook',
      addCTA: 'Ajouter un call-to-action',
      shorterForX: 'Raccourcir pour X (280 car.)',
    },
    saved: 'Enregistrer',
    containsImage: 'Contient une image',
    deleteImage: 'Supprimer l\'image',
    // Newsletter modal
    modalTitle: 'Newsletter',
    modalDescription: 'Créer et programmer l\'envoi d\'une newsletter avec les posts sélectionnés',
    introduction: 'Introduction',
    introductionPlaceholder: 'Écrivez votre introduction ici...',
    posts: 'Posts',
    postsCount: 'Posts ({count})',
    dragAndDropPosts: 'Glissez-déposez des posts ici...',
    textMode: 'Mode Texte',
    visualMode: 'Mode Visuel',
    preview: 'Aperçu',
    modeConstruction: 'Mode Construction',
    previewMode: 'Prévisualisation',
    htmlMode: 'Code HTML',
    enterHtmlCode: 'Entrez votre code HTML...',
    chooseSendDate: 'Choisir la date d\'envoi',
    settings: 'Paramètres',
    generateWithAI: 'Générer avec l\'IA',
    addPostsFirst: 'Ajoutez des posts d\'abord',
    emailTitle: 'Newsletter - Votre Veille Quotidienne',
    dailyHeadline: 'Votre Veille Quotidienne',
    dailySubheadline: 'Les actualités essentielles, directement dans votre boîte mail',
    copyright: '© 2024 - Tous droits réservés',
    footerText: 'Vous recevez cet email car vous êtes abonné à notre newsletter',
    unsubscribe: 'Se désabonner',
    defaultIntro: 'Voici les dernières actualités et tendances de la semaine...',
    generateFromPosts: 'Générer à partir des posts',
    generateFromQueue: 'Générer à partir {count, plural, =0 {des posts} one {du # post} other {des # posts}} en file d\'attente',
    // Newsletter settings
    settingsTitle: 'Paramètres Newsletter',
    settingsDescription: 'Configurer les destinataires et le modèle HTML de la newsletter',
    contactsList: 'Liste de contacts (CSV)',
    uploadCSV: 'Téléverser un fichier CSV',
    csvFormatExpected: 'Format attendu: email, nom, prénom (optionnel)',
    templateHTML: 'Template HTML',
    uploadHTMLTemplate: 'Téléverser un template HTML',
    templateMustContain: 'Le template doit contenir les balises <div id="introduction"></div> et <div id="posts"></div>',
    currentTemplate: 'Template actuel',
    downloadTemplate: 'Télécharger le template',
    templateDownloaded: 'Template CSV téléchargé',
    contactsUploaded: '{count} contacts importés avec succès',
    noValidContactsFound: 'Aucun contact valide trouvé dans le fichier',
    csvParseError: 'Erreur lors de la lecture du fichier CSV',
    templateUploaded: 'Template HTML importé avec succès',
    templateMissingTags: 'Le template doit contenir les balises id="introduction" et id="posts"',
    htmlParseError: 'Erreur lors de la lecture du fichier HTML',
  },

  // Automatisations
  automations: {
    title: 'Automatisations',
    watch: {
      title: 'Thématiques automatiques',
      enabled: 'Activé',
      frequency: 'Fréquence (jours)',
      frequencyDesc: 'Mettre à jour les thématiques tous les {days} jours',
      period: 'Période analysée (jours)',
      periodDesc: 'Analyser les {period} derniers jours (max: {max})',
      preferredHour: 'Heure de mise à jour',
      preferredHourDesc: 'Les sources seront rafraîchies automatiquement à {hour}h (UTC)',
    },
    generation: {
      title: 'Génération automatique',
      enabled: 'Activé',
      frequency: 'Fréquence (jours)',
      frequencyDesc: 'Générer des posts tous les {days} jours',
      postsCount: 'Nombre de posts par itération',
      postsPerIteration: 'Posts par itération',
      postsDesc: 'Générer {count} posts à chaque itération',
      channels: 'Canaux ciblés',
      selectChannels: 'Sélectionner les canaux',
      noChannels: 'Aucun canal configuré. Créez d\'abord un canal de communication.',
    },
    publication: {
      title: 'Publication automatique',
      enabled: 'Activé',
      frequency: 'Fréquence (jours)',
      frequencyDesc: 'Publier tous les {days} jours',
      postsCount: 'Nombre de posts par itération',
      postsPerIteration: 'Posts par itération',
      postsDesc: 'Publier {count} posts à chaque itération',
      channels: 'Canaux ciblés',
      selectChannels: 'Sélectionner les canaux',
      noChannels: 'Aucun canal configuré. Créez d\'abord un canal de communication.',
    },
    save: 'Enregistrer',
    comingSoon: 'Bientôt disponible',
    featureNotAvailable: 'Cette fonctionnalité n\'est pas encore disponible',
  },

  // Galerie de posts
  posts: {
    // V4-DEMO-POST-UNKNOWN-CHANNEL-BADGE (2026-07-03) — badge affiché à la place
    // du réseau dans PostHeader/ExpandedPostModal quand le post n'a pas de canal
    // (posts démo channelless, cf V4-GEN-CHANNELLESS-DEMO). Remplace le "Unknown"
    // hardcodé, non traduit, qui semblait signaler une erreur.
    unknownChannelLabel: 'Canal inconnu',
    gallery: 'Galerie de propositions',
    queue: 'File d\'attente',
    generate: 'Générer',
    generateNew: 'Générer nouveaux posts',
    createNew: 'Créer un post manuellement',
    duplicate: 'Dupliquer le post',
    showImage: 'Afficher l\'image',
    hideImage: 'Masquer l\'image',
    pdfAttachment: 'PDF attaché — analysé par l\'IA si génération depuis le visuel',
    typeYourContent: 'Griffonnez une idée de post, une anecdote, ou collez un brouillon...',
    draftMode: 'Mode brouillon',
    publications: 'Publications',
    filterByChannel: 'Filtrer par canal',
    filterByDate: 'Filtrer par date',
    filters: 'Filtres',
    search: 'Rechercher',
    searchPlaceholder: 'Rechercher des posts...',
    searchPlaceholderInSpace: 'Rechercher dans {space}...',
    createPost: 'Créer un post',
    generatePosts: 'Générer des posts',
    setupIncompleteTooltip: 'Finalisez la configuration initiale pour accéder à cette fonctionnalité',
    clear: 'Effacer',
    sortBy: 'Trier par',
    sortByChannel: 'Par canal',
    sortByDate: 'Par date',
    sortByAlphabetical: 'Alphabétique',
    sortChannel: 'Canal',
    sortDate: 'Date',
    sortAlphabetical: 'Alphabétique',
    sortAscending: 'Croissant',
    sortDescending: 'Décroissant',
    allChannels: 'Tous les canaux',
    today: 'Aujourd\'hui',
    thisWeek: 'Cette semaine',
    thisMonth: 'Ce mois',
    allTime: 'Tout',
    sortNewest: 'Plus récent',
    sortOldest: 'Plus ancien',
    noPostsGallery: 'Aucune proposition de post',
    noPostsAvailable: 'Aucun post disponible',
    noPostsDescription: 'Commencez par cliquer sur "Générer nouveaux posts" pour créer du contenu pour vos canaux de communication.',
    noPostsDescriptionReadOnly: 'Vous consultez cet espace en lecture seule. Les posts publiés par l\'équipe apparaîtront ici dès qu\'ils seront disponibles.',
    noPostsQueue: 'Aucun post en attente',
    dragHere: 'Glissez-déposez des posts ici ou cliquez sur "Mettre en file d\'attente"',
    scheduledFor: 'Programmé pour',
    generatedOn: 'Généré le',
    deleteConfirm: 'Supprimer ce post ?',
    deleteDescription: 'Cette action est irréversible. Le post sera définitivement supprimé.',
    deleteConfirmDesc: 'Cette action est irréversible. Le post sera définitivement supprimé.',
    unsavedChangesTitle: 'Modifications non sauvegardées',
    unsavedChangesDesc: 'Vous avez des modifications non sauvegardées. Si vous continuez, elles seront perdues.',
    continueWithoutSaving: 'Continuer sans sauvegarder',
    publish: 'Publier',
    publishCount: 'Publier ({count})',
    editPostDetails: 'Détails du post',
    editPostDescription: 'Modifiez le contenu du post, choisissez une date d\'envoi et ajoutez-le à la file d\'attente.',
    date: 'Date',
    period: 'Période',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    content: 'Contenu',
    channel: 'Canal',
    scheduledDate: 'Date planifiée',
    external: 'Externe',
    internal: 'Interne',
    onlyMine: 'Mes posts',
    onlyMineHint: 'Afficher uniquement les posts que j\'ai créés',
    createdOn: 'Créé le',
    scheduledOn: 'Programmé le',
    statusFilter: 'Statut',
    statusAll: 'Tous',
    statusDraft: 'À publier',
    statusScheduled: 'Programmés',
    statusPublished: 'Publiés',
    statusChipScheduled: 'Programmé',
    statusChipPublished: 'Publié',
    statusChipFailed: 'Échec',
    publishFailedTitle: 'La publication a échoué',
    publishFailedGeneric: 'Le réseau social a refusé la publication. Vérifiez que le canal est bien connecté, puis réessayez.',
    publishFailedAttempts: 'Tentatives',
    publishFailedRetryHint: 'Corrigez le post si besoin, puis relancez avec « Publier maintenant ».',
    sourceQualityPrimary: 'Basé sur vos sources',
    sourceQualityWebFallback: 'Complété par une recherche web',
    sourceQualityEsFallback: 'Basé sur votre veille récente',
    sourceQualityNone: 'Généré sans source',
    sourceQualityTooltipPrimary: 'Les informations de ce post proviennent des articles collectés par vos sources.',
    sourceQualityTooltipWebFallback: 'Vos sources ne couvraient pas ce sujet : une recherche web a complété les informations.',
    sourceQualityTooltipEsFallback: 'Ce post s\'appuie sur des contenus récents de votre veille, sans correspondance exacte avec le sujet.',
    sourceQualityTooltipNone: 'Aucune source pertinente trouvée : le contenu est plus générique. Ajoutez des sources pour des posts mieux documentés.',
    scheduledCardTooltip: 'Ce post est déjà programmé — gérez-le depuis la file de publication (colonne de droite).',
    improveDiffTitle: 'Amélioration proposée',
    improveRejected: 'Amélioration ignorée — votre texte d\'origine est conservé',
    media: {
      replaceMediaTitle: 'Remplacer le média ?',
      replaceImageByCarousel: 'Cela supprimera l\'image actuelle et générera un carrousel à la place. L\'image sera définitivement supprimée. Confirmer ?',
      replaceCarouselByImage: 'Cela supprimera le carrousel actuel et le remplacera par une image. Le carrousel sera définitivement supprimé. Confirmer ?',
      replaceGeneric: 'Cela remplacera le média actuel. Confirmer ?',
      replaceConfirm: 'Confirmer le remplacement',
      imageReplacedToast: 'Image remplacée par un carrousel',
      carouselReplacedToast: 'Carrousel remplacé par une image',
    },
    deleteImageTitle: 'Supprimer l\'image',
    editScheduleTitle: 'Modifier la date de programmation',
    publishedOn: 'Publié le',
    publishOn: 'Publier le',
    viewPost: 'Voir le post',
    unschedule: 'Déplanifier',
    cannotScheduleInPast: 'Impossible de programmer dans le passé',
    addImage: 'Image',
    replaceImage: 'Remplacer l\'image',
    generateImage: 'Générer avec l\'IA',
    addContentFirst: 'Ajoutez du contenu d\'abord',
    generatingImage: 'Génération en cours...',
    selectStyle: 'Choisir un style',    selectModel: 'Modèle IA',
    imagePrompt: 'Prompt créatif',    imageGenerated: 'Image générée avec succès',
    imageGenerationError: 'Erreur lors de la génération',
    uploadImage: 'Téléverser une image',
    orGenerateWithAI: 'ou générer avec l\'IA',
    image: {
      label: 'Image',
      promptPreviewLoading: 'Préparation du prompt…',
      promptPreviewError: 'Impossible de générer le prompt',
      promptRateLimited: 'Réessayez dans quelques secondes',
      promptRequired: 'Le prompt ne peut pas être vide',
      editPrompt: 'Modifier le prompt',
      launchGeneration: 'Lancer la génération',
      promptPlaceholder: 'Prompt anglais pour la génération…',
      resetPrompt: 'Réinitialiser le prompt',
      editPlaceholder: 'Modifier l\'image (ex : change le fond, rajeunis la personne)…',
      editLaunch: 'Modifier l\'image',
      editSuccess: 'Image modifiée',
      editError: 'Échec de la modification de l\'image',
      editUnsupported: 'Ce modèle ne permet pas l\'édition d\'image',
    },
    edit: 'Modifier',
    copy: 'Copier',
    improve: 'Améliorer',
    improveWithAi: 'Améliorer le texte',
    improving: 'Amélioration...',
    improveDialogTitle: 'Améliorer avec l\'IA',
    improveDialogDescription: 'Décrivez comment vous souhaitez améliorer ce post',
    improveInstructionsPlaceholder: 'Ex: Rends le plus percutant, ajoute des emojis...',
    improveButton: 'Améliorer',
    improveSuggestions: {
      moreConcise: 'Plus concis',
      moreEngaging: 'Plus engageant',
      addHook: 'Ajouter un hook',
      addCTA: 'Ajouter un call-to-action',
      shorterForX: 'Raccourcir pour X (280 car.)',
    },
    saved: 'Enregistrer',
    containsImage: 'Contient une image',
    improvedByAI: 'Contenu amélioré par l\'IA',
    contentPlaceholder: 'Tapez votre contenu...',
    errorImprovingContent: 'Erreur lors de l\'amélioration du contenu',
    improvedContentSuffix: '✨ Contenu amélioré par l\'IA',
    errorUpdatingChannel: 'Erreur lors de la mise à jour du canal',
    htmlCopied: 'Code HTML copié dans le presse-papiers',
    noPostsSelected: 'Aucun post sélectionné pour la génération',
    calendar: 'Calendrier',
    newsletter: 'Newsletter',
    featureComingSoon: 'Cette fonctionnalité sera bientôt disponible',
    quickSuggestions: 'Suggestions rapides',
    yourInstructions: 'Vos instructions',
    currentContent: 'Contenu actuel',
    qualityScore: 'Score de qualité',
    validationUnavailable: 'Non évalué',
    validationSkippedDesc: 'La validation automatique n\'a pas pu être effectuée pour ce post.',
    retryScoring: 'Réessayer',
    retryScoringTooltip: 'Relancer le scoring de qualité pour ce post',
    rescoringInProgress: 'Scoring…',
    rescoreRateLimited: 'Réessayez dans quelques secondes',
    rescoreSuccess: 'Scoring relancé avec succès',
    rescoreError: 'Le scoring n\'a pas pu être relancé',
    sourcesUsed: 'Sources utilisées pour la génération',
    viewDetails: 'Voir détails',
    viewSource: 'Voir la source',
    tone: 'Ton',
    originality: 'Originalité',
    clarity: 'Clarté',
    engagement: 'Engagement',
    relevance: 'Pertinence',
    overall: 'Global',
    copyContent: 'Copier le contenu',
    regenerate: 'Régénérer',
    regenerateSuccess: 'Nouvelle version générée — retrouvez-la dans votre galerie.',
    regenerateError: 'Erreur lors de la régénération.',
    positioningScore: 'Positionnement',
    toneScore: 'Ton',
    overallScore: 'Global',
    originalityScore: 'Originalité',
    complianceFeedback: 'Retour de l\'agent',
    complianceIssues: 'Points à améliorer',
    complianceSuggestions: 'Suggestions',
    // Tokens techniques renvoyés par l'agent compliance — humanisation FR.
    // Toute nouvelle clé doit aussi être ajoutée dans en.ts et es.ts.
    complianceFlags: {
      language_mismatch: 'Langue incorrecte',
      freshness_risk: 'Risque de fraîcheur (info ancienne)',
      source_incomplete: 'Source incomplète ou manquante',
      source_missing: 'Source manquante',
      unsourced_statistic: 'Statistique sans source',
      template_hook: 'Accroche trop générique',
      generic_content: 'Contenu trop générique',
      tone_mismatch: 'Ton incohérent avec la marque',
      positioning_drift: 'Décalage avec le positionnement',
      originality_low: 'Originalité faible',
      off_topic: 'Hors sujet',
      no_cta: 'Pas d\'appel à l\'action',
      too_long: 'Trop long pour la plateforme',
      too_short: 'Trop court',
      hashtags_overuse: 'Trop de hashtags',
      buzzwords_overuse: 'Trop de buzzwords',
      missing_citation: 'Citation manquante',
      duplicate_idea: 'Idée déjà présente dans le batch',
    },
    noPostsForDay: 'Aucun post pour ce jour',
    schedule: 'Programmer',
    publishNow: 'Publier maintenant',
    previousPage: 'Précédent',
    nextPage: 'Suivant',
  },

  // V4-ZERNIO-ANALYTICS 2026-05-28
  analyticsTab: {
    title: 'Analytics',
    period: 'Période :',
    days: 'j',
    impressions: 'Impressions',
    reach: 'Reach',
    likes: 'Likes',
    comments: 'Commentaires',
    engagement: 'Engagement',
    publications: 'Publications',
    onPeriod: 'sur {days} derniers jours',
    byNetwork: 'Par réseau',
    postsCount: '{count} pubs · {rate} eng.',
    impLabel: 'imp.',
    likesLabel: 'likes',
    noPublications: "Aucune publication publiée sur cette période — les analytics apparaîtront après publication.",
    noSpace: 'Aucun espace sélectionné.',
    loadError: 'Impossible de charger les analytics.',
    refresh: 'Rafraîchir',
  },

  // V4-ZERNIO-COMMENTS 2026-05-28
  engagementTab: {
    title: 'Engagement',
    statusUnreplied: 'À répondre',
    statusReplied: 'Répondus',
    statusAll: 'Tous',
    emptyUnreplied: 'Pas de commentaire en attente — bravo !',
    emptyOther: 'Aucun commentaire trouvé.',
    noSpace: 'Aucun espace sélectionné.',
    loadError: 'Impossible de charger les commentaires.',
    refresh: 'Rafraîchir',
    anonymous: 'Anonyme',
    replied: 'Répondu',
    yourReply: 'Votre réponse :',
    replyPlaceholder: 'Votre réponse…',
    cancel: 'Annuler',
    send: 'Envoyer',
    reply: 'Répondre',
    like: 'Like',
    alreadyLiked: 'Déjà liké',
    hide: 'Masquer',
    alreadyHidden: 'Déjà masqué',
    replySuccess: 'Réponse publiée.',
    replyFailed: 'Échec de la publication de la réponse.',
    hideSuccess: 'Commentaire masqué.',
    hideFailed: 'Échec du masquage.',
    likeFailed: 'Échec du like.',
  },

  // V4-ZERNIO-ANALYTICS-POST-CARD 2026-05-28
  postAnalytics: {
    title: 'Analytics du post',
    viewBtn: 'Voir les analytics du post',
    lastSnapshot: 'Dernier snapshot',
    history: 'Historique ({count} snapshots)',
    refresh: 'Rafraîchir',
    refreshed: 'Analytics rafraîchies.',
    refreshFailed: 'Impossible de rafraîchir.',
    loadError: 'Impossible de charger les analytics.',
    impressions: 'Impressions',
    reach: 'Reach',
    likes: 'Likes',
    comments: 'Commentaires',
    engagement: 'Engagement',
    shares: 'Partages',
    colDate: 'Date',
    colImpressions: 'Imp.',
    colLikes: 'Likes',
    colEngagement: 'Eng.',
    noSnapshot: "Aucun snapshot encore. Cliquez sur « Rafraîchir » pour récupérer les analytics en live depuis Zernio.",
  },

  // Couleurs
  colors: {
    primary: 'Couleur principale',
    background: 'Surface',
    surface: 'Fond',
    border: 'Bordures',
    textPrimary: 'Texte principal',
    textSecondary: 'Texte secondaire',
    textLight: 'Accentuation claire',
    accent: 'Accentuation foncée',
    success: 'Succès',
    warning: 'Avertissement',
    danger: 'Danger',
  },

  // Génération de post à partir d'un visuel pré-uploadé (image / carrousel / PDF)
  generateFromVisual: {
    button: 'Générer le texte à partir de ce visuel',
    buttonShort: 'Générer depuis le visuel',
    briefLabel: 'Intention / contexte (optionnel)',
    briefPlaceholder: 'Ex : annonce du lancement produit, leçon tirée d\'un projet client, etc.',
    generate: 'Générer le texte',
    generating: 'Génération…',
    success: 'Texte généré à partir de ton visuel',
    error: 'Échec de la génération à partir du visuel',
    confirmOverwrite: 'Le texte actuel sera remplacé par le texte généré à partir du visuel.',
    confirmOverwriteTitle: 'Remplacer le texte actuel ?',
    confirm: 'Confirmer',
    cancel: 'Annuler',
    regenerate: 'Régénérer',
    phaseInit: 'Préparation…',
    phaseVisual: 'Analyse du visuel…',
    phaseWriting: 'Rédaction du post…',
    phaseCompliance: 'Validation finale…',
    phaseFinalize: 'Sauvegarde…',
  },

  // Modal de génération
  generate: {
    title: 'Générer de nouveaux posts',
    description: 'Sélectionnez les canaux pour lesquels vous souhaitez générer du contenu :',
    forcedSectionTitle: 'Orienter la génération (optionnel)',
    forcedTopicLabel: 'Parler d\'une actualité précise',
    forcedTopicPlaceholder: 'Ex : la sortie de GPT-5, une étude récente sur le télétravail...',
    forcedUrlLabel: 'Forcer un lien source',
    forcedUrlPlaceholder: 'https://exemple.com/article-interessant',
    postsPerChannel: 'Nombre de posts par canal',
    postsCount: 'Nombre de posts',
    periodBack: 'Période de veille',
    channels: 'Canaux',
    noChannelsTitle: 'Aucun canal connecté',
    noChannelsHint: 'Connectez au moins un réseau social pour générer des posts.',
    connectChannel: 'Connecter un canal',
    cancel: 'Annuler',
    close: 'Fermer',
    generate: 'Générer',
    start: 'Lancer la génération',
    generating: 'Génération...',
    inProgress: 'Génération en cours...',
    viewProgress: 'Voir la progression',
    error: 'Erreur lors de la génération des posts',
    noPostsFound: 'Aucun post trouvé dans la base de données pour les critères sélectionnés.',
    fromToday: 'Depuis aujourd\'hui',
    backendNotDeployed: 'Le serveur backend n\'est pas encore déployé. Veuillez d\'abord déployer le serveur Supabase Edge Function via la ligne de commande : npx supabase functions deploy make-server-b017c5b0',
    serverError: 'Erreur serveur',
    errorFetchingPosts: 'Erreur lors de la récupération des posts',
    platformPositioning: 'Positionnement spécifique',
    platformPositioningPlaceholder: 'Optionnel : angle ou ton spécifique pour ce réseau (ex: plus corporate sur LinkedIn, plus décontracté sur X...)',
    imageProvider: "Générateur d'images",
    // Zernio publishing
    publishNow: 'Publier maintenant',
    schedule: 'Programmer',
    publishing: 'Publication en cours…',
    publishSuccess: 'Post publié avec succès',
    publishError: 'Erreur lors de la publication',
    validationFailed: 'Validation échouée',
    noChannelSelected: 'Veuillez sélectionner un canal',
    contentEmpty: 'Le contenu ne peut pas être vide',
    characterLimitExceeded: 'Limite de caractères dépassée',
    mediaRequired: 'Un média est requis pour cette plateforme',
    titleRequired: 'Un titre est requis pour cette plateforme',
    // Validation messages (usePublishValidation)
    noPostSelected: 'Aucun post sélectionné',
    contentEmptyValidation: 'Le contenu du post est vide',
    characterLimitDetail: 'Le contenu dépasse la limite ({count}/{max} caractères)',
    nearCharacterLimit: 'Proche de la limite de caractères ({percentage}%)',
    noChannelAssigned: 'Aucun canal de publication assigné',
    videoRequiredFor: 'Un fichier vidéo est requis pour {platform}',
    mediaRequiredFor: 'Un média (image ou vidéo) est requis pour {platform}',
    titleRecommendedFor: 'Un titre est recommandé pour {platform}',
    publishAttempts: 'Tentatives de publication : {count}',
    statusPublished: 'Publié',
    statusScheduled: 'Programmé',
    statusFailed: 'Échec',
    statusDraft: 'Brouillon',
    // Pipeline d'agents
    pipeline: {
      memory:     { label: 'Mémoire',    tooltip: 'Analyse l\'historique de vos publications et mémorise vos préférences éditoriales.' },
      knowledge:  { label: 'Recherche',  tooltip: 'Collecte les actualités, tendances et sources pertinentes depuis votre veille.' },
      writer:     { label: 'Rédaction',  tooltip: 'Rédige les posts en respectant votre ton, votre style et votre positionnement.' },
      diversity:  { label: 'Variété',    tooltip: 'Diversifie les formats, angles et structures pour éviter la répétition.' },
      compliance: { label: 'Charte',     tooltip: 'Vérifie la conformité avec votre charte éditoriale et valide le positionnement.' },
      finalize:   { label: 'Validation', tooltip: 'Finalise et valide l\'ensemble des posts avant de les livrer.' },
    },
  },

  // Platform-specific fields
  platformFields: {
    sectionTitle: 'Paramètres spécifiques à la plateforme',
    title: 'Titre',
    titlePlaceholder: 'Titre de la publication',
    subreddit: 'Subreddit',
    subredditPlaceholder: 'r/monsubreddit',
    flairId: 'Flair ID',
    flairIdPlaceholder: 'ID du flair (optionnel)',
    boardId: 'Board Pinterest',
    boardIdPlaceholder: 'ID du tableau Pinterest',
    linkUrl: 'URL du lien',
    linkUrlPlaceholder: 'https://example.com',
    visibility: 'Visibilité',
    category: 'Catégorie',
    categoryPlaceholder: 'Catégorie YouTube',
    privacyLevel: 'Confidentialité',
    callToAction: 'Appel à l\'action',
    callToActionPlaceholder: 'En savoir plus, Acheter, etc.',
    eventTitle: 'Titre de l\'événement',
    eventTitlePlaceholder: 'Nom de l\'événement',
    eventStart: 'Début de l\'événement',
    eventEnd: 'Fin de l\'événement',
  },

  // Messages toast
  toasts: {
    // V4-21 — Upload media
    uploadError: 'Échec de l\'upload de l\'image. Réessaie.',
    // Channels
    channelAddedTitle: 'Canal ajouté',
    channelAddedDesc: 'Le canal {name} a été créé avec succès.',
    channelUpdatedTitle: 'Canal mis à jour',
    channelUpdatedDesc: 'Le canal {name} a été modifié.',
    channelNoPositioningTitle: 'Positionnement spécifique non défini',
    channelNoPositioningDesc: 'Ce canal utilisera le positionnement général. Personnalise un positionnement dédié à ce réseau pour des publications mieux ciblées.',
    channelDeletedTitle: 'Canal supprimé',
    channelDeletedDesc: 'Le canal de communication a été supprimé.',
    channelAddError: 'Erreur lors de l\'ajout du canal',
    channelUpdateError: 'Erreur lors de la mise à jour du canal',
    channelDeleteError: 'Erreur lors de la suppression du canal',
    channelLoadError: 'Erreur lors du chargement des canaux',

    // Topics
    topicAddedTitle: 'Sujet ajouté',
    topicAddedDesc: 'Le sujet "{keywords}" a été créé avec succès.',
    topicUpdatedTitle: 'Sujet mis à jour',
    topicUpdatedDesc: 'Le sujet "{keywords}" a été mis à jour.',
    topicDeletedTitle: 'Sujet supprimé',
    topicDeletedDesc: 'Le sujet a été supprimé avec succès.',
    topicAddError: 'Erreur lors de l\'ajout du sujet',
    topicUpdateError: 'Erreur lors de la mise à jour du sujet',
    topicDeleteError: 'Erreur lors de la suppression du sujet',

    // Sources
    sourceAdded: 'Source ajoutée',
    sourceAddedDesc: 'La source "{name}" a été ajoutée avec succès.',
    sourceUpdated: 'Source mise à jour',
    sourceUpdatedDesc: 'Les paramètres de la source ont été sauvegardés.',
    sourceDeleted: 'Source supprimée',
    sourceDeletedDesc: 'La source a été retirée de votre espace.',
    sourceUnlinked: 'Source dissociée',
    sourceUnlinkedDesc: 'La source a été dissociée.',
    sourceAddError: 'Erreur lors de l\'ajout de la source',
    sourceUpdateError: 'Erreur lors de la mise à jour',
    sourceDeleteError: 'Erreur lors de la suppression',
    // V4-SOURCES-LLM-BG 2026-05-29 — FINDING-SOURCES-02 : worker LLM indispo,
    // backend a déclenché la génération en arrière-plan, on rassure l'user.
    keywordsBackground: 'Service de génération temporairement indisponible. Réessayez dans quelques instants.',
    noSpaceSelected: 'Aucun espace sélectionné',
    // Génération
    generating: 'Génération des posts en cours...',
    noChannelSelected: 'Aucun canal sélectionné',
    noPostGenerated: 'Aucun post généré',
    postsGenerated: '{count} post(s) généré(s) avec succès',
    postsGeneratedFeedbackHint: 'Si les résultats ne vous conviennent pas, partagez votre avis à l\'agent de positionnement pour améliorer les prochaines générations.',
    partialGeneration: '{delivered} post(s) généré(s) sur {requested} demandé(s) — contenu trop similaire, réessayez avec un autre sujet.',
    generationCancelled: 'Génération annulée',
    generationError: 'Erreur: {message}',
    generationTimeout: 'La génération a expiré',
    generationTimeoutDesc: 'Le service est lent en ce moment. Vous pouvez réessayer dans un instant.',
    imageGenerationTimeout: 'La génération d\'image a expiré',
    imageGenerationTimeoutDesc: 'Le service est lent en ce moment. Vous pouvez réessayer dans un instant.',
    fromVisualTimeout: 'La génération à partir du visuel a expiré',
    fromVisualTimeoutDesc: 'Le service est lent en ce moment. Vous pouvez réessayer dans un instant.',
    retry: 'Réessayer',
    // Détection de nouvelle version (bundle SPA périmé)
    updateAvailableTitle: 'Nouvelle version disponible',
    updateAvailableDesc: 'Rechargez la page pour appliquer la mise à jour.',
    reload: 'Recharger',
    // Amélioration
    improving: 'Amélioration du post...',
    postImproved: 'Post amélioré',
    improveError: 'Erreur: {message}',
    improveTimeout: 'L\'amélioration a expiré',
    improveTimeoutDesc: 'Le service est lent en ce moment. Vous pouvez réessayer dans un instant.',
    // Synchronisation
    syncing: 'Synchronisation des sources...',
    syncSuccess: '{count} source(s) synchronisée(s)',
    syncError: 'Erreur lors de la synchronisation',
    sourceSyncing: 'Synchronisation en cours...',
    sourceSyncSuccess: 'Source synchronisée avec succès',
    sourceSyncError: 'Erreur lors de la synchronisation de la source',
    sourceSyncTimeout: 'Synchronisation en cours en arrière-plan...',
    syncAllStarted: 'Synchronisation séquentielle de {count} source(s)...',
    syncAllCompleted: 'Toutes les sources ont été synchronisées',
    syncAllPartial: '{success} source(s) synchronisée(s), {failed} en erreur',
    // Copie
    contentCopied: 'Contenu copié dans le presse-papiers',
    copyError: 'Impossible de copier le contenu',
    // Posts
    postSaved: 'Post sauvegardé',
    postSavedDesc: 'Vos modifications ont été enregistrées avec succès',
    postUpdated: 'Post mis à jour',
    postUpdatedDesc: 'Les modifications ont été sauvegardées dans votre galerie',
    postCreated: 'Post créé',
    postCreatedDesc: 'Votre nouveau post a été ajouté à la galerie',
    postDeleted: 'Post supprimé',
    postDeletedDesc: 'Le post a été retiré de la liste',
    postScheduled: 'Post programmé',
    postScheduledDesc: 'Le post a été ajouté à la file d\'attente',
    scheduleFailed: 'Programmation impossible',
    scheduleFailedDesc: 'Le post n\'a pas pu être programmé. Réessayez.',
    postPublished: 'Post publié',
    postPublishedDesc: 'Le post a été publié avec succès via Zernio',
    postPublishError: 'Erreur de publication',
    postPublishErrorDesc: 'Impossible de publier le post : {error}',
    postDuplicated: 'Post dupliqué',
    postDuplicatedDesc: 'Une copie du post a été ajoutée à la galerie',
    postChannelUpdated: 'Canal mis à jour',
    postChannelUpdatedDesc: 'Le post est maintenant associé à ce nouveau canal',
    imageAdded: 'Image ajoutée',
    imageAddedDesc: 'L\'image a été associée au post',
    imageRemoved: 'Image supprimée',
    imageRemovedDesc: 'L\'image a été retirée du post',
    galleryCleared: 'Galerie vidée',
    galleryClearedDesc: 'Tous les posts ont été supprimés',
    // Newsletter
    newsletterGenerated: 'Newsletter générée avec {count} post(s)',
    // Positionnement
    positioning: {
      saveSuccess: 'Positionnement sauvegardé',
      saveError: 'Erreur lors de la sauvegarde du positionnement',
      loadError: 'Erreur lors du chargement du positionnement',
    },
    saveError: 'Erreur lors de la sauvegarde',
    // V4-POS-06 2026-05-29 — scraping URL en mode dégradé (backend hors ligne, AI gère)
    scrapingDegraded: 'Analyse du site temporairement indisponible — l\'assistant continue sans.',
    // Général
    success: 'Succès',
    error: 'Erreur',
    warning: 'Attention',
    info: 'Information',
  },

  // Modal de confirmation
  confirm: {
    clearGalleryTitle: 'Confirmation de suppression',
    clearGalleryDescription: 'Confirmez-vous la suppression de tous les posts de la galerie ?',
    clearGalleryQuestion: 'Vider la galerie ?',
    clearGalleryWarning: 'Cette action supprimera tous les posts de la galerie.',
    irreversible: 'Cette action est irréversible.',
    cancel: 'Annuler',
    clearGallery: 'Vider la galerie',
    delete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
    unsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous continuer ?',
    confirmDeleteAllData: 'Êtes-vous sûr de vouloir supprimer toutes les données ?',
  },

  // Modal des publications
  publications: {
    title: 'Publications programmées',
    description: 'Liste de tous les posts publiés',
    noPublications: 'Aucune publication programmée',
    publishedOn: 'Publié le',
    at: 'à',
    delete: 'Supprimer',
    deleteConfirm: 'Supprimer cette publication ?',
    deleteDescription: 'Cette action est irréversible. La publication sera supprimée définitivement.',
  },

  // Tutoriel Youtube
  youtubeTutorial: {
    title: 'Comment trouver l\'ID de chaîne YouTube',
    description: 'Guide pour trouver l\'identifiant unique d\'une chaîne YouTube',
    method1Title: 'Méthode 1 : Via la page "À propos"',
    method1Step1: 'Accédez à la chaîne YouTube souhaitée',
    method1Step2: 'Cliquez sur l\'onglet "À propos"',
    method1Step3: 'Cliquez sur "Partager" puis "Copier l\'ID de la chaîne"',
    method2Title: 'Méthode 2 : Via l\'URL de la chaîne',
    method2Step1: 'Allez sur la page de la chaîne YouTube',
    method2Step2: 'Regardez l\'URL dans la barre d\'adresse',
    method2Step3: 'L\'ID de la chaîne commence généralement par "UC" et contient 24 caractères',
    method2ExampleUrl: 'Exemple d\'URL :',
    method3Title: 'Méthode 3 : Pour les chaînes avec @username',
    method3Step1: 'Si la chaîne utilise un @username (ex: @monusername)',
    method3Step2: 'Allez sur youtube.com/@monusername',
    method3Step3: 'Faites un clic droit → "Voir le code source de la page"',
    method3Step4: 'Recherchez "channelId" dans le code (Ctrl+F)',
    method3Step5: 'L\'ID de la chaîne se trouve juste après',
    tip: 'Astuce :',
    tipText: 'L\'ID de chaîne YouTube (Canonical ID) commence toujours par "UC" et contient exactement 24 caractères alphanumériques.',
    example: 'Exemple :',
    gotIt: 'Compris',
  },

  // Charte graphique (chantier L 2026-05)
  brandConfig: {
    title: 'Charte graphique',
    description: 'Vos couleurs, polices et logo — extraits automatiquement de votre site. Vos carrousels et images générés par l\'IA les réutilisent pour rester cohérents avec votre marque. Modifiables à tout moment.',
    landingUrl: 'URL de la landing page',
    landingUrlPlaceholder: 'https://votre-site.com',
    reExtract: 'Re-extraire la charte',
    reExtracting: 'Extraction en cours…',
    statusPending: 'Extraction en cours…',
    statusFailed: 'Extraction échouée',
    statusFailedRetry: 'Réessayer',
    palette: 'Palette de couleurs',
    paletteEmpty: 'Aucune couleur détectée',
    fonts: 'Fonts',
    fontsEmpty: 'Aucune font détectée',
    images: 'Images détectées',
    imagesEmpty: 'Aucune image détectée',
    artisticDirection: 'Direction artistique',
    artisticDirectionPlaceholder: 'Décrivez en quelques mots le style visuel souhaité…',
    artisticDirectionEmpty: 'Aucune direction artistique. Cliquez sur éditer pour en ajouter une.',
    artisticTagPlaceholder: 'Ajouter un tag puis Entrée…',
    preview: 'Aperçu',
    previewTitle: 'Titre exemple',
    previewText: 'Exemple : vos carrousels et images reprendront ces couleurs et polices.',
    previewCta: 'Bouton CTA',
    refreshError: 'Impossible de rafraîchir',
    copyColorPrefix: 'Copier',
    save: 'Enregistrer',
    saveSuccess: 'Charte mise à jour',
    saveError: 'Erreur lors de la mise à jour',
    copyHex: 'Copier',
    copied: 'Copié',
    colorRolePrimary: 'Primaire',
    colorRoleSecondary: 'Secondaire',
    colorRoleAccent: 'Accent',
    colorRoleBackground: 'Fond',
    colorRoleText: 'Texte',
    colorRoleMuted: 'Atténué',
    imageTypeLogo: 'Logo',
    imageTypeHero: 'Image principale',
    imageTypeAdditional: 'Image additionnelle',
    noLandingUrl: 'Aucune URL n\'a encore été renseignée pour ce space. Renseignez-la pour lancer l\'extraction de la charte.',
    // UX fix 20-05 — Mode saisie manuelle
    manualModeShow: 'Pas de site web ? Saisir manuellement',
    manualModeHide: 'Masquer la saisie manuelle',
    manualAddColor: 'Ajouter une couleur',
    manualAddFont: 'Ajouter une police (nom Google Font ou nom de famille)',
    manualAddImage: 'Ajouter une image (URL publique)',
    manualFontPlaceholder: 'Ex: Inter, Roboto, Poppins…',
    manualHint: 'Les éléments ajoutés ici sont sauvegardés immédiatement et utilisés par Raiso.',
    add: 'Ajouter',
    remove: 'Supprimer',
    replace: 'Remplacer',
    invalidHex: 'Format hex invalide (ex: #5500FF)',
    invalidImageUrl: 'URL invalide (doit commencer par http(s)://)',
    // V4-BRAND-01 2026-05-29 — panneau erreur extraction + actions
    extractionFailed: 'Nous n\'avons pas pu analyser votre site. Vous pouvez réessayer ou configurer manuellement.',
    extractionRetry: 'Réessayer',
    extractionManual: 'Configurer manuellement',
    extractionSlow: 'L\'extraction prend plus de temps que prévu. Vous pouvez patienter encore un peu ou réessayer.',
    extractionReset: 'Extraction réinitialisée',
    extractionResetError: 'Impossible de réinitialiser l\'extraction',
    // V4-BRAND-02 2026-05-29 — circuit breaker polling
    pollingLost: 'Connexion perdue, reconnexion en cours…',
  },

  // Boutons communs
  common: {
    freePlan: 'Plan Free',
    reactivate: 'Réactiver',
    draft: 'Brouillon',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    selectedLabel: 'sélectionnés',
    addSelection: 'Ajouter sélection',
    adding: 'Ajout…',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    add: 'Ajouter',
    close: 'Fermer',
    loading: 'Chargement...',
    copy: 'Copier',
    confirm: 'Confirmer',
    back: 'Retour',
    next: 'Suivant',
    search: 'Rechercher',
    filter: 'Filtrer',
    reset: 'Réinitialiser',
    refresh: 'Actualiser',
    validate: 'Valider',
    saveChanges: 'Enregistrer les modifications',
    unknownChannel: 'Canal inconnu',
    confirmDeleteAllData: 'Êtes-vous sûr de vouloir supprimer toutes les données ?',
    type: 'Type',
    weekDays: ['L', 'M', 'M', 'J', 'V', 'S', 'D'],
    characters: 'caractères',
    viewSource: 'Voir la source',
    others: 'autres',
    or: 'ou',
    optional: 'optionnel',
  },

  // Temps relatif
  time: {
    justNow: 'À l\'instant',
    minutesAgo: 'il y a {count} min',
    hoursAgo: 'il y a {count}h',
    daysAgo: 'il y a {count}j',
    neverSynced: 'Jamais synchronisé',
  },

  // Types de sources pour la traçabilité
  sourceTypes: {
    rss: 'Flux RSS',
    rss_feed: 'Flux RSS',
    youtube: 'YouTube',
    video: 'Vidéo',
    website: 'Site web',
    url: 'URL',
    raw_text: 'Texte brut',
    text: 'Texte',
    document: 'Document',
    pdf: 'PDF',
    podcast: 'Podcast',
    unknown: 'Source',
  },

  // Session expirée
  session: {
    expiredTitle: 'Session expirée',
    expiredDescription: 'Votre session a expiré. Veuillez vous reconnecter.',
  },

  // Aide YouTube pour SourceForm
  youtubeHelp: {
    title: '💡 Comment trouver l\'ID de la chaîne YouTube :',
    step1: 'Allez sur la page de la chaîne YouTube',
    step2: 'L\'ID se trouve dans l\'URL :',
    step3: 'Ou cliquez droit → "Afficher le code source" → Recherchez "channelId"',
    note: 'L\'ID commence toujours par "UC" suivi de 22 caractères.',
    rawTextHelp: 'Collez ici vos notes internes, informations de veille, ou tout contenu que vous souhaitez utiliser pour la génération de posts.',
  },

  // Composants UI génériques
  ui: {
    sidebar: {
      title: 'Barre latérale',
      mobileDescription: 'Affiche la barre latérale mobile',
    },
    carousel: {
      previous: 'Diapositive précédente',
      next: 'Diapositive suivante',
    },
    pagination: {
      more: 'Plus de pages',
      next: 'Suivant',
      previous: 'Précédent',
    },
    dialog: {
      close: 'Fermer',
    },
  },

  // Modal de sélection de compte (headless OAuth)
  accountSelection: {
    title: 'Connecter {platform}',
    loading: 'Chargement...',
    noOptions: 'Aucune option disponible.',
    retryButton: 'Réessayer',
    connectButton: 'Connecter',
    connecting: 'Connexion...',
    loadError: 'Impossible de charger les options. Veuillez réessayer.',
    connectError: 'Erreur lors de la connexion. Veuillez réessayer.',
    subtitles: {
      linkedin: 'Choisissez comment vous souhaitez publier',
      facebook: 'Choisissez la page depuis laquelle publier',
      pinterest: 'Choisissez le tableau à connecter',
      googlebusiness: 'Choisissez votre établissement',
      snapchat: 'Choisissez votre profil public',
      default: 'Choisissez un compte',
    },
  },

  // OAuth / Connexion réseaux sociaux
  oauth: {
    connect: 'Connecter {{network}}',
    connecting: 'Connexion en cours...',
    disconnect: 'Déconnecter',
    refresh: 'Actualiser le token',
    notSupported: 'OAuth non disponible',
    confirmDisconnect: 'Êtes-vous sûr de vouloir déconnecter ce compte ?',
    confirmDisconnectTitle: 'Déconnecter le compte',
    confirmDisconnectDescription: 'Êtes-vous sûr de vouloir déconnecter ce compte ? L\'historique ne sera pas supprimé.',
    confirmDisconnectAction: 'Déconnecter',
    connected: 'Connecté',
    needsRefresh: 'Token expiré',
    expired: 'Non connecté',
    error: 'Erreur de connexion',
    success: 'Connecté !',
    selectPage: 'Sélectionner une page',
    selectAccount: 'Sélectionner un compte',
    noPages: 'Aucune page Facebook trouvée',
    noAccounts: 'Aucun compte Instagram trouvé',
    pageRequired: 'Vous devez sélectionner une page pour publier',
    accountRequired: 'Vous devez sélectionner un compte Instagram pour publier',
    processing: 'Connexion en cours...',
    processingMessage: 'Veuillez patienter pendant que nous finalisons la connexion.',
    successMessage: 'Votre compte a été connecté avec succès. Cette fenêtre va se fermer automatiquement.',
  },

  // Zernio / Connexion réseaux sociaux via Zernio (getlate.dev)
  socials: {
    connect: 'Connecter le compte',
    connecting: 'Connexion en cours…',
    connected: 'Connecté',
    disconnect: 'Déconnecter',
    reconnect: 'Reconnecter',
    refreshConnection: 'Rafraîchir la connexion',
    expired: 'Token expiré',
    notConnected: 'Non connecté',
    connectNow: 'Connecter maintenant',
    connectPrompt: 'Connectez ce réseau pour publier vos posts',
    connectReminderTitle: 'Canal créé — pensez à le connecter',
    connectReminderBody: 'Connectez votre réseau pour pouvoir publier les posts générés.',
    notSupported: 'Non supporté',
    confirmDisconnect: 'Êtes-vous sûr de vouloir déconnecter ce compte social ?',
    confirmDisconnectTitle: 'Déconnecter le compte',
    confirmDisconnectDescription: 'Êtes-vous sûr de vouloir déconnecter ce compte social ? L\'historique ne sera pas supprimé.',
    confirmDisconnectAction: 'Déconnecter',
    manage: 'Gérer la connexion',
    callbackProcessing: 'Finalisation de la connexion…',
    callbackSuccess: 'Compte connecté avec succès ! Cette fenêtre va se fermer.',
    callbackError: 'Erreur lors de la connexion. Veuillez réessayer.',
    channelsUsed: 'canaux utilisés',
    tokenExpiresIn: 'Expire dans {{days}} jours',
    tokenExpiresSoon: 'Token expire bientôt',
    reconnectRequired: 'Reconnexion nécessaire',
    telegramConnected: 'Telegram connecté',
    telegramCodeExpired: 'Code expiré, veuillez réessayer',
    codeCopied: 'Code copié',
    telegramSetup: 'Connexion Telegram',
    telegramInstructions: 'Instructions :',
    telegramStep1: 'Ajoutez @LateScheduleBot comme administrateur dans votre canal/groupe',
    telegramStep2: 'Ouvrez un chat privé avec @LateScheduleBot',
    telegramStep3: 'Envoyez le code ci-dessus suivi de @votrecanal',
    telegramStep4: 'Attendez la confirmation automatique ci-dessus',
    openBot: 'Ouvrir @LateScheduleBot',
    profileAlreadyExists: 'Un profil avec ce nom existe déjà sur cette plateforme.',
    connectionError: 'Erreur lors de la connexion au compte social.',
    popupBlocked: 'Fenêtre pop-up bloquée. Autorisez les pop-ups pour ce site, puis réessayez.',
  },

  // Langues disponibles
  languages: {
    fr: 'Français',
    en: 'English',
    es: 'Español',
    de: 'Deutsch',
    it: 'Italiano',
    pt: 'Português',
    nl: 'Nederlands',
    pl: 'Polski',
    ru: 'Русский',
    zh: '中文',
    ja: '日本語',
    ar: 'العربية',
  },

  // WebSocket Messages (standardized i18n keys from backend)
  quota: {
    aiCredits: 'Crédits IA',
    used: 'utilisé',
    warning: 'Attention : consommation élevée de crédits IA',
    exceeded: 'Quota dépassé — renouvellement le 1er du mois prochain',
    accountTitle: 'Mon compte',
    creditsSection: 'Consommation IA',
    creditsDescription: 'Votre consommation de crédits IA pour la période en cours.',
    renewal: 'Renouvellement automatique chaque 1er du mois.',
    quotaExceededToast: 'Crédits IA épuisés. Renouvellement automatique le 1er du mois prochain.',
    quotaExceededTopupToast: 'Crédits IA épuisés. Rechargez vos crédits ou attendez le renouvellement le 1er du mois.',
    quotaExceededTooltip: 'Quota IA épuisé — renouvellement le 1er du mois.',
    quotaExceededTitle: 'Quota IA dépassé',
    textBudget: 'Budget texte',
    images: 'Images',
    videos: 'Vidéos',
    comingSoon: 'Bientôt disponible',
    subscription: 'Abonnement',
    of: 'sur',
    // Topup
    purchasedCredits: 'Crédits achetés',
    topupTitle: 'Recharger vos crédits IA',
    topupDescription: 'Achetez des crédits supplémentaires pour votre compte.',
    topupPlanInfo: 'Rechargez vos crédits IA',
    topupOneTime: 'Paiement unique — crédits persistants',
    topupBuyButton: 'Recharger des crédits',
    topupClose: 'Fermer',
    topupLoading: 'Chargement...',
    topupQuantity: 'Quantité',
    topupCreditsLabel: 'Crédits',
    topupUnitPrice: 'Prix unitaire',
    topupCreditsUnit: 'crédits',
    topupCurrentBalance: 'Crédits achetés restants :',
    topupSuccessTitle: 'Recharge effectuée !',
    topupSuccessMessage: 'Vos crédits IA ont été rechargés avec succès !',
    topupErrorTitle: 'Erreur',
    topupLoadError: 'Impossible de charger les informations de recharge.',
    topupPurchaseError: 'Échec de la recharge. Veuillez réessayer.',
    topupCancelledMessage: 'Recharge annulée.',
    topupVatAtCheckout: 'TVA calculée au paiement',
  },
  ws: {
    // V4-UX-WS-I18N-FALLBACK 2026-07-02 — libellé générique quand le backend envoie
    // une i18n_key inconnue du front sans message : évite une étape vide/technique.
    fallbackStep: 'Traitement en cours…',
    generation: {
      started: 'Génération de {{count}} post(s) pour {{platform}}...',
      connecting: 'Connexion au serveur...',
      completed: '✓ {{count}} post(s) généré(s)',
      failed: '❌ Erreur: {{error}}',
    },
    memory: {
      loading: 'Chargement de l\'historique...',
      loaded: '{{posts_count}} posts et {{hooks_count}} accroches chargés',
    },
    knowledge: {
      searching: 'Recherche de sources pertinentes...',
      semantic_search: 'Analyse sémantique en cours...',
      extracting_metadata: 'Extraction des métadonnées...',
      extracting_facts: 'Extraction des faits clés...',
      found: '{{sources_count}} source(s) et {{facts_count}} fait(s) trouvés',
      none: 'Aucune source pertinente trouvée',
    },
    writing: {
      started: 'Rédaction de {{count}} post(s) pour {{platform}}...',
      post: 'Rédaction du post {{index}}/{{total}}...',
      shortening: 'Optimisation de la longueur du post {{index}}...',
      completed: '{{count}} post(s) rédigé(s)',
      error: 'Erreur de rédaction: {{error}}',
    },
    diversity: {
      checking: 'Vérification de la diversité de {{count}} post(s)...',
      passed: '✓ {{valid_count}} post(s) validé(s)',
      regenerating: '🔄 Régénération de {{invalid_count}} post(s) (tentative {{attempt}}/{{max_attempts}})...',
    },
    compliance: {
      validating: 'Validation de {{count}} post(s)...',
      analyzing: 'Analyse du post {{index}}/{{total}}...',
      approved: '✓ {{count}} post(s) approuvé(s)',
      needs_revision: '{{count}} post(s) nécessitent des modifications',
      iterating: '🔄 Itération {{iteration}}/{{max_iterations}} en cours...',
    },
    finalize: {
      saving: 'Sauvegarde des posts...',
    },
    fallback: {
      started: 'Mode de secours activé...',
      completed: '{{count}} post(s) généré(s) (mode secours)',
    },
  },

  billing: {
    title: 'Facturation',
    subscription: 'Abonnement',
    currentPlan: 'Offre actuelle',
    email: 'Email de facturation',
    invoices: 'Factures',
    noInvoices: 'Aucune facture pour le moment.',
    downloadPdf: 'Télécharger le PDF',
    couponUsed: 'Code promo',
    promoCode: 'Code promo',
    promoCodePlaceholder: 'Entrez votre code promo',
    apply: 'Appliquer',
    toasts: {
      couponApplied: 'Code promo appliqué avec succès.',
      couponError: 'Code promo invalide ou expiré.',
      pdfError: 'Impossible de récupérer la facture.',
      switchIntervalUpdated: 'Votre abonnement a été mis à jour.',
      switchIntervalError: 'Impossible de modifier votre abonnement. Réessayez plus tard.',
      cancelError: 'Impossible d\'annuler votre abonnement. Réessayez plus tard.',
      referralCodeError: 'Impossible de générer votre code de parrainage. Réessayez plus tard.',
    },
    // Subscription management
    billingInterval: 'Facturation',
    monthly: 'Mensuel',
    annual: 'Annuel',
    switchToAnnual: 'Passer en annuel',
    switchToMonthly: 'Passer en mensuel',
    saveWithAnnual: 'Économisez ~17% avec l\'abonnement annuel',
    switchIntervalConfirm: 'Vous allez être redirigé vers la page de paiement pour modifier votre abonnement.',
    // Cancel subscription
    cancelSubscription: 'Annuler mon abonnement',
    cancelConfirmTitle: 'Annuler votre abonnement ?',
    cancelConfirmMessage: 'Votre accès sera maintenu jusqu\'à la fin de votre période de facturation en cours.',
    cancelConfirmButton: 'Confirmer l\'annulation',
    subscriptionCancelled: 'Abonnement annulé. Accès maintenu jusqu\'à la fin de la période.',
    subscriptionEndsAt: 'Accès jusqu\'au',
    statusCancelling: 'Annulation en cours',
    autoRenewal: 'Renouvellement automatique',
    autoRenewalActive: 'Activé',
    // Alerte paiement échoué
    paymentFailed: 'Échec de paiement',
    paymentFailedDescription: 'Mettez à jour votre moyen de paiement avant le {date} pour conserver votre accès Pro.',
    paymentFailedExpired: 'Votre accès Pro a été suspendu suite à un échec de paiement.',
    updatePaymentMethod: 'Mettre à jour',
    // Delete account
    deleteAccount: 'Supprimer mon compte',
    deleteAccountTitle: 'Supprimer votre compte ?',
    deleteAccountWarning: 'Cette action est irréversible. Votre abonnement sera annulé et votre compte désactivé.',
    deleteAccountPasswordLabel: 'Confirmez votre mot de passe',
    deleteAccountPasswordPlaceholder: 'Entrez votre mot de passe actuel',
    deleteAccountConfirmButton: 'Supprimer définitivement',
    deleteAccountSuccess: 'Compte supprimé avec succès.',
    deleteAccountPasswordError: 'Mot de passe incorrect.',
    // Referral / Parrainage
    referralTitle: 'Parrainage',
    referralCode: 'Votre code de parrainage',
    referralCopied: 'Code copié !',
    referralCopyButton: 'Copier',
    referralCount: 'Filleuls',
    referralCountOf: 'sur',
    referralNoCode: 'Générer votre code',
    referralGenerating: 'Génération...',
    myRewards: 'Mes récompenses',
    noRewards: 'Aucune récompense disponible',
    rewardUsed: 'Utilisé',
    applyToRenewal: 'Appliquer au renouvellement',
    rewardApplied: 'Récompense appliquée à votre abonnement !',
    rewardApplyError: 'Erreur lors de l\'application de la récompense',
    // Upgrade
    upgradePlan: 'Passer à un abonnement payant',
    choosePlan: 'Choisir',
    upgradeTitle: 'Changer d\'abonnement',
    selectInterval: 'Facturation',
  },

  // V4-ACCOUNT-01 2026-05-29 — Labels & textes Account Tab
  account: {
    // Role / account-type labels (display d'un raw enum vers libellé lisible)
    roleUser: 'Utilisateur',
    roleAdmin: 'Administrateur',
    roleViewer: 'Lecteur',
    roleAgency: 'Agence',
    roleAgencyOwner: 'Propriétaire d\'agence',
    roleAgencyAdmin: 'Administrateur d\'agence',
    roleAgencyMember: 'Membre d\'agence',
    // Aria-labels
    applyPromoCode: 'Appliquer le code promo',
    // Sections additionnelles
    referralDescription: 'Invitez des collègues et gagnez des crédits pour chaque inscription confirmée.',
    referralLearnMore: 'En savoir plus',
  },

  // Erreurs HTTP globales (apiClient)
  errors: {
    forbidden: 'Accès refusé',
    forbiddenDescription: 'Vous n\'avez pas les permissions nécessaires pour effectuer cette action.',
    tooManyRequests: 'Trop de requêtes',
    tooManyRequestsDescription: 'Vous avez atteint la limite de requêtes. Réessayez dans un instant.',
    serverError: 'Erreur serveur',
    serverErrorDefault: 'Une erreur serveur est survenue.',
    // V4-APICLIENT-INTERCEPTOR 2026-05-29 — mapping erreurs typées backend
    urlScrapingFailed: 'Impossible d\'analyser l\'URL',
    urlScrapingFailedDescription: 'Le contenu de la page n\'a pas pu être récupéré. Vérifiez l\'URL ou réessayez plus tard.',
    llmWorkerUnavailable: 'Service IA momentanément indisponible',
    llmWorkerUnavailableDescription: 'Le worker LLM ne répond pas. Réessayez dans quelques instants.',
    recursionLimitExceeded: 'Génération interrompue',
    recursionLimitExceededDescription: 'L\'agent a atteint sa limite de raisonnement. Simplifiez la demande ou réessayez.',
    upstreamLlmTimeout: 'Délai d\'attente IA dépassé',
    upstreamLlmTimeoutDescription: 'Le fournisseur LLM a mis trop de temps à répondre. Réessayez.',
    agencyPermissionsUnavailable: 'Droits non vérifiables',
    agencyPermissionsUnavailableDescription: 'Impossible de vérifier vos droits d\'accès pour le moment. Réessayez dans un instant.',
    badRequest: 'Requête invalide',
    badRequestDescription: 'La requête envoyée n\'a pas pu être traitée.',
  },

  carousel: {
    title: 'Carrousel',
    generate: 'Générer un carrousel',
    generating: 'Génération en cours…',
    backgroundStarted: 'Génération du carrousel lancée',
    backgroundStartedDescription: 'Vous pouvez fermer cette fenêtre. Le carrousel sera rattaché automatiquement au post.',
    editCarousel: 'Modifier le carrousel',
    addCarousel: 'Ajouter un carrousel',
    removeCarousel: 'Supprimer le carrousel',
    fullRegenerationTitle: 'Régénération complète',
    fullRegenerationDescription: 'Relancez une nouvelle version complète du carrousel pour explorer une autre direction créative.',
    slideRegenerationTitle: 'Régénération du slide sélectionné',
    selectedSlideLabel: 'Slide sélectionné',
    clearInstructions: 'Effacer',
    closeEditor: 'Fermer l’éditeur',
    deleteSectionTitle: 'Suppression du carrousel',
    deleteSectionDescription: 'Cette action détache le carrousel du post et supprime aussi ses fichiers stockés.',
    deleteConfirm: 'Confirmer la suppression',
    deleteSuccess: 'Carrousel supprimé',
    deleteError: 'Erreur lors de la suppression du carrousel',
    containsCarousel: 'Contient un carrousel',
    slides: 'Slides',
    slide: 'Slide',
    slideOf: 'Slide {current} sur {total}',
    aspectRatio: 'Format',
    nSlides: 'Nombre de slides',
    regenerateSlide: 'Régénérer ce slide',
    regenerating: 'Régénération…',
    instructions: 'Instructions de modification',
    instructionsPlaceholder: 'Ex : Rends ce slide plus percutant avec un fond plus sombre…',
    exportPng: 'Exporter en PNG',
    exportPdf: 'Exporter en PDF',
    exportPdfSuccess: 'PDF généré',
    exportPdfError: 'Erreur lors de la génération du PDF',
    exporting: 'Export en cours…',
    exportSuccess: 'Carrousel exporté !',
    exportError: 'Erreur lors de l\'export',
    generationError: 'Erreur lors de la génération du carrousel',
    postNotFound: 'Ce post n’existe plus. Rafraîchissez la page et réessayez.',
    reorderHint: 'Glissez-déposez pour réordonner les slides',
    noSlides: 'Aucun slide',
    previewTitle: 'Aperçu du carrousel',
    chatPlaceholder: 'Décrivez le carrousel à générer…',
    sendMessage: 'Générer',
    ratio_1_1: 'Carré (1:1)',
    ratio_4_5: 'Portrait (4:5)',
    ratio_9_16: 'Stories / Reels (9:16)',
  },
  // V4-NEWSLETTER-TEMPLATES-FR-ONLY-DUPLICATED 2026-07-30 — copie du gabarit d'email
  // newsletter, jusque-là en français en dur dans 4 fichiers. Consommée par
  // `buildNewsletterHtml` (src/utils/newsletterUtils.ts).
  newsletterTemplate: {
    documentTitle: 'Newsletter',
    heading: '🚀 Votre veille',
    subtitle: 'Les actualités essentielles, directement dans votre boîte mail',
    introHeading: 'Au sommaire',
    introBody: 'Découvrez la sélection d\'actualités et de tendances retenues pour vous cette période.',
    ctaHeading: 'Envie d\'aller plus loin ?',
    ctaLabel: 'Découvrir nos solutions',
    postImageAlt: 'Illustration du post',
    rights: 'Tous droits réservés',
    subscriptionNotice: 'Vous recevez cet email car vous êtes inscrit à notre newsletter.',
  },
};

export type TranslationKeys = typeof fr;